<template>
  <div>
    <b-modal
      id="modal-role-cases"
      ref="my-modal-cases"
      cancel-variant="outline-secondary"
      centered
      :title="$t('DEBTIA_ADD_CASE')"
      size="lg"
      hide-footer
      no-close-on-backdrop
      @hide="resetCaseModal"
    >
      <b-overlay
        id="overlay-background"
        :show="loader === true"
        variant="dark"
        opacity="0.85"
        blur="2px"
        rounded="sm"
        spinner-variant="primary"
        spinner-medium
      >
        <div
          v-if="noinput"
          class="demo-spacing-0 mb-1"
        >
          <b-alert
            variant="warning"
            show
          >
            <div class="alert-body">
              {{ noinputmsg }}
            </div>
          </b-alert>
        </div>
        <Busy
          :busy-status="busy"
          :processing-status="processing"
          :busy-text="busytext"
        />
        <form-wizard
          ref="wizard"
          color="#7367F0"
          :title="null"
          :subtitle="null"
          layout="vertical"
          :finish-button-text="$t('DEBTIA_SUBMIT')"
          :back-button-text="$t('DEBTIA_PREVIOUS')"
          :next-button-text="nextButton"
          class="wizard-vertical mb-3"
          @on-change="handleTabChange"
          @on-complete="formSubmitted"
        >
          <!-- social link -->
          <keep-alive>
            <tab-content
              :title="$t('DEBTIA_CONFIRM')"
            >
              <b-row
                class="invoice-preview"
              >
                <b-col
                  cols="12"
                  xl="12"
                  md="12"
                >
                  <b-card
                    no-body
                    class="invoice-preview-card mt-1"
                  >
                    <b-card-body
                      id="bcardbody"
                      class="invoice-padding"
                    >

                      <div
                        id="first-div"
                        class="d-flex justify-content-between flex-md-row flex-column invoice-spacing mt-0"
                      >

                        <!-- Header: Left Content -->
                        <div class="first-p">
                          <div class="confirmation-text">
                            <h4 class="text-primary">
                              {{ $t('DEBTIA_CONFIRMATION') }}
                            </h4>
                          </div>
                          <h5>
                            {{ $t('DEBTIA_CLIENT') }}
                          </h5>
                          <div class="invoice-date-wrapper">
                            <p class="invoice-date-title first-p">
                              {{ $t('DEBTIA_NAME') }}
                            </p>
                            <p class="invoice-date">
                              {{ summaryClientName }}
                            </p>
                          </div>
                          <div class="invoice-date-wrapper">
                            <p class="invoice-date-title first-p">
                              {{ $t('DEBTIA_ID') }}
                            </p>
                            <p class="invoice-date">
                              {{ summaryClientId }}
                            </p>
                          </div>
                          <div class="invoice-date-wrapper">
                            <h5 class="invoice-date-title first-p">
                              {{ $t('DEBTIA_BASE_TYPE') }}
                            </h5>
                            <p class="invoice-date">
                              {{ summaryDocumentBaseType }}
                            </p>
                          </div>
                        </div>

                      </div>
                    </b-card-body>

                    <!-- Spacer -->
                    <hr class="invoice-spacing">
                    <b-row class="ml-2 mb-1">

                      <!-- Col: Invoice To -->
                      <b-col
                        cols="12"
                        xl="6"
                        class="p-0"
                      >
                        <h4>
                          {{ $t('DEBTIA_BASE_DOCUMENT') }}
                        </h4>
                      </b-col>
                    </b-row>

                    <!-- Invoice Description: Table -->
                    <b-table-lite
                      responsive
                      class="record-table"
                      :items="summaryBaseDocuments"
                      :fields="['title', 'restAmount', 'interestRate', 'fileLink']"
                    >
                      <template #cell(title)="data">
                        <b-card-text class="font-weight-bold mb-25">
                          {{ data.item.title }}
                        </b-card-text>
                      </template>
                      <template #cell(restAmount)="data">
                        <b-card-text class="font-weight-bold mb-25">
                          {{ formatCurrency(data.item.total_amount, defaultCurrency) }}
                        </b-card-text>
                      </template>
                      <template #cell(interestRate)="data">
                        <b-card-text class="font-weight-bold mb-25">
                          {{ (data.item.interest_rate_agreed) ? (data.item.interest_rate_percentage) + '%' : (data.item.interest_rate_percentage) + '% standard process rente' }}
                        </b-card-text>
                      </template>
                      <template #cell(fileLink)="data">
                        <b-button
                          v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                          variant="outline-primary"
                          :href="data.item.file_link"
                          target="_blank"
                        >
                          <feather-icon
                            icon="ExternalLinkIcon"
                            size="14"
                          />
                        </b-button>
                      </template>
                    </b-table-lite>
                    <!-- Spacer -->
                    <div v-if="summaryCreditNotes.length > 0">
                      <hr class="invoice-spacing">
                      <b-row class="ml-2 mb-1">

                        <!-- Col: Invoice To -->
                        <b-col
                          cols="12"
                          xl="6"
                          class="p-0"
                        >
                          <h4>
                            {{ $t('DEBTIA_CREDIT_NOTES') }}
                          </h4>
                        </b-col>
                      </b-row>

                      <!-- Invoice Description: Table -->
                      <b-table-lite
                        responsive
                        class="record-table"
                        :items="summaryCreditNotes"
                        :fields="['no', 'amount', 'fileLink']"
                      >
                        <template #cell(no)="">
                          <b-card-text class="font-weight-bold mb-25">
                            1
                          </b-card-text>
                        </template>
                        <template #cell(amount)="data">
                          <b-card-text class="font-weight-bold mb-25">
                            {{ formatCurrency(data.item.credit_note_amount, defaultCurrency) }}
                          </b-card-text>
                        </template>
                        <template #cell(fileLink)="data">
                          <b-button
                            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                            variant="outline-primary"
                            :href="data.item.file_link"
                            target="_blank"
                          >
                            <feather-icon
                              icon="ExternalLinkIcon"
                              size="14"
                            />
                          </b-button>
                        </template>
                      </b-table-lite>
                    </div>
                    <div v-if="summaryDebtReminders.length > 0">
                      <!-- Spacer -->
                      <hr class="invoice-spacing">
                      <b-row class="ml-2 mb-0">

                        <!-- Col: Invoice To -->
                        <b-col
                          cols="12"
                          xl="12"
                          class="p-0"
                        >
                          <h4>
                            {{ $t('DEBTIA_DEBT_REMINDER') }}
                          </h4>
                        </b-col>
                        <b-col
                          v-if="!capitalCompanyActive"
                          cols="12"
                          xl="12"
                          class="p-0"
                        >
                          <label
                            style="color: red;"
                          >
                            <small>{{ $t('DEBTIA_DEBTOR_IS_COMPANY') }}</small>
                          </label>
                        </b-col>
                      </b-row>

                      <!-- Invoice Description: Table -->
                      <b-table-lite
                        responsive
                        class="record-table"
                        :items="summaryDebtReminders"
                        :fields="['no', 'reminderFee', 'compensationFee', 'fileLink']"
                      >
                        <template #cell(no)="">
                          <b-card-text class="font-weight-bold mb-25">
                            1
                          </b-card-text>
                        </template>
                        <template #cell(reminderFee)="data">
                          <b-card-text class="font-weight-bold mb-25">
                            {{ formatCurrency(data.item.reminder_fee, defaultCurrency) }}
                          </b-card-text>
                        </template>
                        <template #cell(compensationFee)="data">
                          <b-card-text class="font-weight-bold mb-25">
                            {{ !capitalCompanyActive ? '0 '+defaultCurrencySymbol+' ' : formatCurrency(data.item.compensation_fee, defaultCurrency) }}
                          </b-card-text>
                        </template>
                        <template #cell(fileLink)="data">
                          <b-button
                            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                            variant="outline-primary"
                            :href="data.item.file_link"
                            target="_blank"
                          >
                            <feather-icon
                              icon="ExternalLinkIcon"
                              size="14"
                            />
                          </b-button>
                        </template>
                      </b-table-lite>
                    </div>
                    <!-- Spacer -->
                    <div v-if="summaryOtherFiles.length > 0">
                      <hr class="invoice-spacing">
                      <b-row class="ml-2 mb-1">

                        <!-- Col: Invoice To -->
                        <b-col
                          cols="12"
                          xl="6"
                          class="p-0"
                        >
                          <h4>
                            {{ $t('DEBTIA_OTHER_FILES') }}
                          </h4>
                        </b-col>
                      </b-row>

                      <!-- Invoice Description: Table -->
                      <b-table-lite
                        responsive
                        class="record-table"
                        :items="summaryOtherFiles"
                        :fields="['title', 'category', 'fileLink']"
                      >
                        <template #cell(title)="data">
                          <b-card-text class="font-weight-bold mb-25">
                            {{ data.item.title }}
                          </b-card-text>
                        </template>
                        <template #cell(category)="data">
                          <b-card-text class="font-weight-bold mb-25">
                            {{ data.item.category ? data.item.category : 'N/A' }}
                          </b-card-text>
                        </template>
                        <template #cell(fileLink)="data">
                          <b-button
                            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                            variant="outline-primary"
                            :href="data.item.file_link"
                            target="_blank"
                          >
                            <feather-icon
                              icon="ExternalLinkIcon"
                              size="14"
                            />
                          </b-button>
                        </template>
                      </b-table-lite>
                    </div>
                    <!-- Spacer -->
                    <hr class="invoice-spacing">
                    <b-row class="ml-2 mb-1">

                      <!-- Col: Invoice To -->
                      <b-col
                        cols="12"
                        xl="6"
                        class="p-0"
                      >
                        <h4>
                          {{ $t('DEBTIA_DEBTORS') }}
                        </h4>
                      </b-col>
                    </b-row>

                    <!-- Invoice Description: Table -->
                    <b-table-lite
                      responsive
                      class="record-table"
                      :items="summaryDebtors"
                      :fields="['debtorId', 'debtorName', 'debtorType', 'debtorEmail', 'debtorPhone']"
                    >
                      <template #cell(debtorId)="data">
                        <b-card-text class="font-weight-bold mb-25">
                          {{ data.item.id }}
                        </b-card-text>
                      </template>
                      <template #cell(debtorName)="data">
                        <b-card-text class="font-weight-bold mb-25">
                          {{ data.item.name }}
                        </b-card-text>
                      </template>
                      <template #cell(debtorType)="data">
                        <b-card-text class="font-weight-bold mb-25">
                          {{ data.item.debtor_type }}
                        </b-card-text>
                      </template>
                      <template #cell(debtorEmail)="data">
                        <b-card-text class="font-weight-bold mb-25">
                          <a :href="'mailto:' + data.item.email">{{ data.item.email }}</a>
                        </b-card-text>
                      </template>
                      <template #cell(debtorPhone)="data">
                        <b-card-text class="font-weight-bold mb-25">
                          {{ data.item.phone }}
                        </b-card-text>
                      </template>
                    </b-table-lite>
                    <hr class="invoice-spacing">
                    <!-- Note -->
                    <b-card-body class="invoice-padding pt-0">
                      <span class="font-weight-bold mb-2">
                        {{ $t('debtors_owes_statement') }} {{ summaryTotalDebtAmount }}
                      </span>
                      <hr class="invoice-spacing">
                      <span class="font-weight-bold">
                        <b-form-checkbox
                          id="confirmationCheck"
                          class="custom-control-primary"
                        >
                          {{ $t('DEBTIA_CONFIRMATION_TEXT') }}
                        </b-form-checkbox> </span>
                    </b-card-body>
                  </b-card>
                </b-col>
              </b-row>
            </tab-content>
          </keep-alive>
          <!-- base document tab -->
          <keep-alive>
            <tab-content
              :title="$t('DEBTIA_BASE_TYPE')"
              :before-change="stepone"
            >
              <b-row
                class="border-bottom"
              >
                <b-col
                  cols="12"
                  class="base-doc"
                >
                  <b-card-body>
                    <!-- metting header -->
                    <div class="meetup-header align-items-center">
                      <div class="my-auto my-auto-1">
                        <b-card-text class="mb-0">
                          <h5>{{ $t('DEBTIA_SELECT_CLIENT_BASETYPE') }}.</h5>
                        </b-card-text>
                      </div>
                    </div>
                    <!--/ metting header -->

                  </b-card-body>
                </b-col>
              </b-row>
              <b-row
                class="border-bottom"
              >
                <b-col
                  cols="12"
                  class="base-doc"
                >
                  <b-col
                    md="12"
                    class="col-margin"
                  >
                    <b-card>
                      <b-card-text
                        class="card-text-styling"
                      >
                        <b-overlay
                          :show="clientsLoader"
                          rounded="lg"
                          opacity="0.6"
                        >
                          <template #overlay>
                            <div class="d-flex align-items-center">
                              <b-spinner
                                small
                                type="grow"
                                variant="secondary"
                              />
                              <b-spinner
                                type="grow"
                                variant="dark"
                              />
                              <b-spinner
                                small
                                type="grow"
                                variant="secondary"
                              />

                              <!-- We add an SR only text for screen readers -->
                              <span class="sr-only">Please wait...</span>
                            </div>
                          </template>

                          <b-form-group
                            class="classformgroup"
                            :label="$t('DEBTIA_CLIENT')"
                            label-for="debtor-login-status"
                          >
                            <v-select
                              v-model="selectedClient"
                              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                              :options="clientsOptions"
                              :reduce="val => val.value"
                              :clearable="false"
                              input-id="debtor-login-status"
                            />
                            <b-alert
                              v-if="caseMaxLimit"
                              show
                              variant="danger"
                              class="mt-1 mb-1 p-1"
                            >
                              {{ $t('DEBTIA_MAXIMUM_CASES_WARNING') }}
                            </b-alert>
                          </b-form-group>
                        </b-overlay>
                      </b-card-text>
                    </b-card>
                  </b-col>
                </b-col>
              </b-row>
              <b-row
                class="border-bottom"
              >
                <b-col
                  cols="6"
                  class="base-doc"
                >
                  <b-col
                    md="12"
                    class="col-margin"
                  >
                    <b-card>
                      <b-card-text
                        class="card-text-styling"
                      >
                        <b-overlay
                          :show="termsheetCodeLoader"
                          rounded="lg"
                          opacity="0.6"
                        >
                          <template #overlay>
                            <div class="d-flex align-items-center">
                              <b-spinner
                                small
                                type="grow"
                                variant="secondary"
                              />
                              <b-spinner
                                type="grow"
                                variant="dark"
                              />
                              <b-spinner
                                small
                                type="grow"
                                variant="secondary"
                              />

                              <!-- We add an SR only text for screen readers -->
                              <span class="sr-only">Please wait...</span>
                            </div>
                          </template>

                          <b-form-group
                            class="classformgroup"
                            :label="$t('DEBTIA_CASE_GROUPS')"
                            label-for="debtor-login-status"
                          >
                            <v-select
                              v-model="selectedCaseGroup"
                              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                              :options="caseGroupsOptions"
                              :reduce="val => val.value"
                              :clearable="false"
                              input-id="debtor-login-status"
                            />
                          </b-form-group>
                        </b-overlay>
                      </b-card-text>
                    </b-card>
                  </b-col>
                </b-col>
                <b-col
                  cols="6"
                  class="base-doc"
                >
                  <b-col
                    md="12"
                    class="col-margin"
                  >
                    <b-card>
                      <b-card-text
                        class="card-text-styling"
                      >
                        <b-overlay
                          :show="termsheetCodeLoader"
                          rounded="lg"
                          opacity="0.6"
                        >
                          <template #overlay>
                            <div class="d-flex align-items-center">
                              <b-spinner
                                small
                                type="grow"
                                variant="secondary"
                              />
                              <b-spinner
                                type="grow"
                                variant="dark"
                              />
                              <b-spinner
                                small
                                type="grow"
                                variant="secondary"
                              />

                              <!-- We add an SR only text for screen readers -->
                              <span class="sr-only">Please wait...</span>
                            </div>
                          </template>

                          <b-form-group
                            class="classformgroup"
                            :label="$t('DEBTIA_TERMSHEETCODE')"
                            label-for="debtor-login-status"
                          >
                            <v-select
                              v-model="selectedTermsheetCode"
                              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                              :options="termSheetCodeOptions"
                              :reduce="val => val.value"
                              :clearable="false"
                              input-id="debtor-login-status"
                            />
                          </b-form-group>
                        </b-overlay>
                      </b-card-text>
                    </b-card>
                  </b-col>
                </b-col>
              </b-row>
              <b-row class="mt-1">
                <b-col md="6">
                  <div
                    class="base-type-options card icon-card cursor-pointer text-center mb-2 mx-50"
                    :class="activeOption === 1 ? 'active' : '' "
                    @click="selectOption(1)"
                  >
                    <div class="card-body">
                      <div class="icon-wrapper">
                        <feather-icon
                          icon="AirplayIcon"
                          class="mr-25"
                        />
                      </div><p class="card-text icon-name text-truncate mb-0 mt-1">
                        Invoice (Faktura)</p></div></div>
                </b-col>
                <b-col md="6">
                  <div
                    class="base-type-options card icon-card cursor-pointer text-center mb-2 mx-50"
                    :class="activeOption === 2 ? 'active' : '' "
                    @click="selectOption(2)"
                  >
                    <div class="card-body">
                      <div class="icon-wrapper">
                        <feather-icon
                          icon="UserIcon"
                          class="mr-25"
                        />
                      </div><p class="card-text icon-name text-truncate mb-0 mt-1">
                        Court Verdict (Dom) </p></div></div>
                </b-col>
                <b-col md="6">
                  <div
                    class="base-type-options card icon-card cursor-pointer text-center mb-2 mx-50"
                    :class="activeOption === 3 ? 'active' : '' "
                    @click="selectOption(3)"
                  >
                    <div class="card-body">
                      <div class="icon-wrapper">
                        <feather-icon
                          icon="ClipboardIcon"
                          class="mr-25"
                        />
                      </div><p class="card-text icon-name text-truncate mb-0 mt-1">
                        Promissory note<br>(Gældsbrev) </p></div></div>
                </b-col>
                <b-col md="6">
                  <div
                    class="base-type-options card icon-card cursor-pointer text-center mb-2 mx-50"
                    :class="activeOption === 4 ? 'active' : '' "
                    @click="selectOption(4)"
                  >
                    <div class="card-body">
                      <div class="icon-wrapper">
                        <feather-icon
                          icon="CircleIcon"
                          class="mr-25"
                        />
                      </div><p class="card-text icon-name text-truncate mb-0 mt-1">
                        Undefined/Other<br>(Andet) </p></div></div>
                </b-col>
              </b-row>
            </tab-content>
          </keep-alive>
          <!-- base document tab -->
          <keep-alive>
            <tab-content
              :title="$t('DEBTIA_BASE_DOCUMENT')"
              :before-change="steptwo"
            >
              <b-row
                class="border-bottom"
              >
                <b-col
                  cols="12"
                  class="base-doc"
                >
                  <b-card-body>
                    <!-- metting header -->
                    <div class="meetup-header align-items-center">
                      <div class="my-auto my-auto-1">
                        <b-card-title class="mb-25">
                          {{ $t('DEBTIA_BASE_DOCUMENT') }}
                        </b-card-title>
                        <b-card-text class="mb-0">
                          {{ $t('DEBTIA_ADD_BASE_DOCUMENT') }}
                        </b-card-text>
                      </div>
                      <div class="meetup-day meetup-day-1">
                        <b-button
                          v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                          variant="outline-primary"
                          class="btn-icon rounded-circle"
                          @click="addBaseDocument"
                        >
                          <feather-icon icon="PlusIcon" />
                        </b-button>
                      </div>
                    </div>
                    <!--/ metting header -->

                  </b-card-body>
                </b-col>
              </b-row>
              <b-row>
                <b-table
                  ref="innertable"
                  class="position-relative modal-table baseDocumentTable"
                  :no-border-collapse="noCollapse"
                  sticky-header="360px"
                  responsive
                  :fields="tableFields"
                  :items="items"
                  primary-key="index"
                  hover
                >
                  <template #table-colgroup="scope">
                    <col
                      v-for="field in scope.fields"
                      :key="field.key"
                      :style="{ width: field.key === 'details' || field.key === 'removeRecord' ? '15px' : '' }"
                    >
                  </template>
                  <template
                    #cell(removeRecord)="data"
                  >
                    <div class="demo-inline-spacing">
                      <b-button
                        v-if="data.item.index !== 1"
                        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                        variant="warning"
                        class="btn-icon margin-top-zero margin-right-ten delete-record"
                        @click="removeItem('basedocuments', data.item.index)"
                      >
                        <feather-icon icon="XIcon" />
                      </b-button>
                    </div>
                  </template>
                  <template
                    #cell(details)="data"
                  >
                    <div class="demo-inline-spacing">
                      <b-button
                        :id="'basedocuments-btn-'+data.item.index"
                        v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                        variant="outline-primary"
                        class="btn-icon margin-top-zero margin-right-zero"
                        @click="openDetails('basedocuments', data)"
                      >
                        <feather-icon :icon="data.detailsShowing ? 'ChevronUpIcon' : 'ChevronDownIcon'" />
                      </b-button>
                    </div>
                  </template>
                  <template #row-details="data">
                    <b-card>
                      <b-row class="mb-2">
                        <b-col
                          sm="10"
                          offset-sm="1"
                        >
                          <b-row class="mb-2">
                            <b-col
                              :id="'basedocuments-file-div-'+data.item.index"
                              sm="12"
                            >
                              <b-form-file
                                :id="'basedocuments-file-'+data.item.index"
                                :ref="'basedocuments-file-'+data.item.index"
                                @change="validateFile('basedocuments', $event, data.item.index)"
                              />
                              <label
                                :for="'basedocuments-file-'+data.item.index"
                                data-browse="Browse"
                                class="custom-file-label"
                              ><span
                                :id="'basedocuments-file-span-'+data.item.index"
                                class="d-block form-file-text"
                                style="pointer-events: none;"
                              >No File Selected</span></label>
                            </b-col>
                            <b-col
                              sm="12"
                              class="mt-1"
                            >
                              <b-input-group
                                :prepend="$t('DEBTIA_TITLE')+'*'"
                              >
                                <b-form-input
                                  :id="'basedocument_'+data.item.index+'_title'"
                                  v-model="data.item.fullData.title"
                                  @change="wizardFieldChange('basedocuments', data.item.index)"
                                />
                              </b-input-group>
                            </b-col>
                            <b-col
                              sm="12"
                              class="mt-1"
                            >
                              <b-input-group
                                :prepend="$t('DEBTIA_SENT_AT')+'*'"
                              >
                                <cleave
                                  id="date"
                                  v-model="data.item.fullData.daSentAt"
                                  class="form-control"
                                  :raw="false"
                                  :options="options.date"
                                  placeholder="DD-MM-YYYY"
                                  @input="validateDate('basedocuments', 'senddateerror', data.item.index, data.item.fullData, 'daSentAt', 'sentAt'), dueDateValidity('basedocuments', data.item.index, data.item.fullData), wizardFieldChange('basedocuments', data.item.index)"
                                />
                                <b-input-group-append>
                                  <b-form-datepicker
                                    v-model="data.item.fullData.sentAt"
                                    :date-format-options="{ day: 'numeric', month: 'numeric', year: 'numeric' }"
                                    trim
                                    button-only
                                    right
                                    size="sm"
                                    @input="dueDateValidity('basedocuments', data.item.index, data.item.fullData), wizardFieldChange('basedocuments', data.item.index), assignDateValue($event, data.item.fullData, 'daSentAt')"
                                  />
                                </b-input-group-append>
                              </b-input-group>
                              <label
                                :id="'basedocuments-senddateerror-'+data.item.index"
                                style="color: red; display:none;"
                              >*{{ $t('DEBTIA_DATE_FORMAT_ERROR') }}</label>
                            </b-col>
                            <b-col
                              sm="12"
                              class="mt-1"
                            >
                              <b-input-group
                                :prepend="$t('DEBTIA_DUE_DATE')+'*'"
                              >
                                <cleave
                                  id="date"
                                  v-model="data.item.fullData.daDueDate"
                                  class="form-control"
                                  :raw="false"
                                  :options="options.date"
                                  placeholder="DD-MM-YYYY"
                                  @input="validateDate('basedocuments', 'duedateformaterror', data.item.index, data.item.fullData, 'daDueDate', 'dueDate'), dueDateValidity('basedocuments', data.item.index, data.item.fullData), wizardFieldChange('basedocuments', data.item.index)"
                                />
                                <b-input-group-append>
                                  <b-form-datepicker
                                    v-model="data.item.fullData.dueDate"
                                    :date-format-options="{ day: 'numeric', month: 'numeric', year: 'numeric' }"
                                    trim
                                    button-only
                                    right
                                    size="sm"
                                    @input="dueDateValidity('basedocuments', data.item.index, data.item.fullData), wizardFieldChange('basedocuments', data.item.index), assignDateValue($event, data.item.fullData, 'daDueDate')"
                                  />
                                </b-input-group-append>
                              </b-input-group>
                              <label
                                :id="'basedocuments-duedateerror-'+data.item.index"
                                style="color: red; display:none;"
                              >*{{ $t('DEBTIA_DUEDATE_LESSER_ERROR') }}</label>
                              <label
                                :id="'basedocuments-duedateformaterror-'+data.item.index"
                                style="color: red; display:none;"
                              >*{{ $t('DEBTIA_DATE_FORMAT_ERROR') }}</label>
                            </b-col>
                            <b-col
                              sm="12"
                              class="mt-1"
                            >
                              <b-input-group
                                :prepend="$t('DEBTIA_PAYMENT_AMOUNT')+'*'"
                                :append="defaultCurrencySymbol"
                              >
                                <b-form-input
                                  v-model="data.item.fullData.paymentAmount"
                                  type="number"
                                  @change="paymentValidity('basedocuments', data.item.index, $event, 'paymentamounterror')"
                                />
                              </b-input-group>
                              <label
                                :id="'basedocuments-paymentamounterror-'+data.item.index"
                                style="color: red; display:none;"
                              >*{{ $t('DEBTIA_AMOUNT_ERROR') }}</label>
                            </b-col>
                            <b-col
                              sm="12"
                              class="mt-1"
                            >
                              <b-input-group
                                :prepend="$t('DEBTIA_VAT_AMOUNT')"
                                :append="defaultCurrencySymbol"
                              >
                                <b-form-input
                                  v-model="data.item.fullData.vatAmount"
                                  type="number"
                                  @change="wizardFieldChange('basedocuments', data.item.index)"
                                />
                              </b-input-group>
                            </b-col>
                          </b-row>
                          <b-row class="mb-2">
                            <b-col
                              sm="6"
                            >
                              <b-form-group>
                                <b-input-group>
                                  <b-input-group-prepend is-text>
                                    <b-form-checkbox
                                      :id="'amountPaidCheckbox-'+data.item.index"
                                      :ref="'amountPaidCheckbox-'+data.item.index"
                                      v-model="data.item.fullData.amountPaid.status"
                                      name="checkbox-input"
                                      class="custom-control-primary"
                                      @change="checkboxActivationFunction(`paidamountref-${data.item.index}`, `amountPaidCheckbox-${data.item.index}`, `amountPaidCheckboxMask-${data.item.index}`, data.item.index)"
                                    />
                                  </b-input-group-prepend>
                                  <b-form-input
                                    :id="'amountPaidCheckboxMask-'+data.item.index"
                                    :value="$t('DEBTIA_AMOUNT_PAID')"
                                    readonly
                                  />
                                </b-input-group>
                              </b-form-group>
                            </b-col>
                            <b-col
                              sm="6"
                            >
                              <b-form-group>
                                <b-input-group
                                  :append="defaultCurrencySymbol"
                                >
                                  <b-form-input
                                    :id="'paidamountref-'+data.item.index"
                                    v-model="data.item.fullData.amountPaid.value"
                                    type="number"
                                    readonly
                                    @change="wizardFieldChange('basedocuments', data.item.index)"
                                  />
                                </b-input-group>
                              </b-form-group>
                            </b-col>
                          </b-row>
                          <b-row class="mb-2">
                            <b-col
                              sm="6"
                            >
                              <b-form-group>
                                <b-input-group>
                                  <b-input-group-prepend is-text>
                                    <b-form-checkbox
                                      :id="'interestRateCheckbox-'+data.item.index"
                                      :ref="'interestRateCheckbox-'+data.item.index"
                                      v-model="data.item.fullData.interestRate.status"
                                      name="checkbox-input"
                                      class="custom-control-primary"
                                      @change="checkboxActivationFunction(`interestfieldref-${data.item.index}`, `interestRateCheckbox-${data.item.index}`, `interestRateCheckboxMask-${data.item.index}`, data.item.index)"
                                    />
                                  </b-input-group-prepend>
                                  <b-form-input
                                    :id="'interestRateCheckboxMask-'+data.item.index"
                                    :value="$t('DEBTIA_INTEREST_RATE')"
                                    readonly
                                  />
                                </b-input-group>
                              </b-form-group>
                            </b-col>
                            <b-col
                              sm="6"
                            >
                              <b-form-group>
                                <b-input-group
                                  :append="$t('DEBTIA_PERCENT')"
                                >
                                  <b-form-input
                                    :id="'interestfieldref-'+data.item.index"
                                    v-model="data.item.fullData.interestRate.value"
                                    type="number"
                                    readonly
                                    @change="wizardFieldChange('basedocuments', data.item.index)"
                                  />
                                </b-input-group>
                              </b-form-group>
                            </b-col>
                          </b-row>
                          <b-button
                            size="sm"
                            @click="data.toggleDetails"
                          >
                            {{ $t('DEBTIA_HIDE_DETAILS') }}</b-button>
                        </b-col>
                      </b-row>
                    </b-card>
                  </template>
                </b-table>
              </b-row>
            </tab-content>
          </keep-alive>
          <!-- Credit Notes -->
          <keep-alive>
            <tab-content
              :title="$t('DEBTIA_CREDIT_NOTES')"
              :before-change="stepthree"
            >
              <b-row
                class="border-bottom"
              >
                <b-col
                  cols="12"
                  class="base-doc"
                >
                  <b-card-body>
                    <!-- metting header -->
                    <div class="meetup-header align-items-center">
                      <div class="my-auto my-auto-1">
                        <b-card-title class="mb-25">
                          {{ $t('DEBTIA_CREDIT_NOTES') }}
                        </b-card-title>
                        <b-card-text class="mb-0">
                          {{ $t('DEBTIA_ADD_CREDIT_NOTES') }}
                        </b-card-text>
                      </div>
                      <div class="meetup-day meetup-day-1">
                        <b-button
                          v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                          variant="outline-primary"
                          class="btn-icon rounded-circle"
                          @click="addCreditNotes"
                        >
                          <feather-icon icon="PlusIcon" />
                        </b-button>
                      </div>
                    </div>
                    <!--/ metting header -->

                  </b-card-body>
                </b-col>
              </b-row>
              <b-row>
                <b-table
                  v-if="creditNoteitems.length > 0"
                  ref="innertable"
                  class="position-relative modal-table baseDocumentTable"
                  :no-border-collapse="noCollapse"
                  sticky-header="360px"
                  responsive
                  :fields="tableFields"
                  :items="creditNoteitems"
                  primary-key="index"
                  hover
                >
                  <template #table-colgroup="scope">
                    <col
                      v-for="field in scope.fields"
                      :key="field.key"
                      :style="{ width: field.key === 'details' || field.key === 'removeRecord' ? '15px' : '' }"
                    >
                  </template>
                  <template
                    #cell(removeRecord)="data"
                  >
                    <div class="demo-inline-spacing">
                      <b-button
                        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                        variant="warning"
                        class="btn-icon margin-top-zero margin-right-ten delete-record"
                        @click="removeItem('creditnotes', data.item.index)"
                      >
                        <feather-icon icon="XIcon" />
                      </b-button>
                    </div>
                  </template>
                  <template
                    #cell(details)="data"
                  >
                    <div class="demo-inline-spacing">
                      <b-button
                        :id="'creditnotes-btn-'+data.item.index"
                        v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                        variant="outline-primary"
                        class="btn-icon margin-top-zero margin-right-zero"
                        @click="openDetails('creditnotes', data)"
                      >
                        <feather-icon :icon="data.detailsShowing ? 'ChevronUpIcon' : 'ChevronDownIcon'" />
                      </b-button>
                    </div>
                  </template>
                  <template #row-details="data">
                    <b-card>
                      <b-row class="mb-2">
                        <b-col
                          sm="10"
                          offset-sm="1"
                        >
                          <b-row class="mb-2">
                            <b-col
                              :id="'creditnotes-file-div-'+data.item.index"
                              sm="12"
                            >
                              <b-form-file
                                :id="'creditnotes-file-'+data.item.index"
                                :ref="'creditnotes-file-'+data.item.index"
                                @change="validateFile('creditnotes', $event, data.item.index)"
                              />
                              <label
                                :for="'creditnotes-file-'+data.item.index"
                                data-browse="Browse"
                                class="custom-file-label"
                              ><span
                                :id="'creditnotes-file-span-'+data.item.index"
                                class="d-block form-file-text"
                                style="pointer-events: none;"
                              >No File Selected</span></label>
                            </b-col>
                            <b-col
                              sm="12"
                              class="mt-1"
                            >
                              <b-input-group
                                :prepend="$t('DEBTIA_SENT_AT')+'*'"
                              >
                                <cleave
                                  id="date"
                                  v-model="data.item.fullData.daSentAt"
                                  class="form-control"
                                  :raw="false"
                                  :options="options.date"
                                  placeholder="DD-MM-YYYY"
                                  @input="validateDate('creditnotes', 'senddateerror', data.item.index, data.item.fullData, 'daSentAt', 'sentAt'), wizardFieldChange('creditnotes', data.item.index)"
                                />
                                <b-input-group-append>
                                  <b-form-datepicker
                                    v-model="data.item.fullData.sentAt"
                                    :date-format-options="{ day: 'numeric', month: 'numeric', year: 'numeric' }"
                                    trim
                                    button-only
                                    right
                                    size="sm"
                                    @input="dueDateValidity('creditnotes', data.item.index, data.item.fullData), wizardFieldChange('creditnotes', data.item.index), assignDateValue($event, data.item.fullData, 'daSentAt')"
                                  />
                                </b-input-group-append>
                              </b-input-group>
                              <label
                                :id="'creditnotes-senddateerror-'+data.item.index"
                                style="color: red; display:none;"
                              >*{{ $t('DEBTIA_DATE_FORMAT_ERROR') }}</label>
                            </b-col>
                            <b-col
                              sm="12"
                              class="mt-1"
                            >
                              <b-input-group
                                :prepend="$t('DEBTIA_AMOUNT_INCLUDING_VAT')+'*'"
                                :append="defaultCurrencySymbol"
                              >
                                <b-form-input
                                  v-model="data.item.fullData.creditNoteAmount"
                                  type="number"
                                  @change="paymentValidity('creditnotes', data.item.index, $event, 'creditNoteError')"
                                />
                              </b-input-group>
                              <label
                                :id="'creditnotes-creditNoteError-'+data.item.index"
                                style="color: red; display:none;"
                              >*{{ $t('DEBTIA_AMOUNT_ERROR') }}</label>
                            </b-col>
                          </b-row>
                          <b-button
                            size="sm"
                            @click="data.toggleDetails"
                          >
                            {{ $t('DEBTIA_HIDE_DETAILS') }}</b-button>
                        </b-col>
                      </b-row>
                    </b-card>
                  </template>
                </b-table>
                <div
                  v-else
                  class="demo-spacing-0 creditnotesalert"
                >
                  <b-alert
                    variant="primary"
                    show
                  >
                    <div class="alert-body">
                      <span>{{ $t('DEBTIA_NO_CREDIT_NOTES_MSG') }}.</span>
                    </div>
                  </b-alert>
                </div>
              </b-row>
            </tab-content>
          </keep-alive>
          <!-- social link -->
          <keep-alive>
            <tab-content
              :title="$t('DEBTIA_DEBT_REMINDER')"
              :before-change="stepfour"
            >
              <b-row
                class="border-bottom"
              >
                <b-col
                  cols="12"
                  class="base-doc"
                >
                  <b-card-body>
                    <!-- metting header -->
                    <div class="meetup-header align-items-center">
                      <div class="my-auto my-auto-1">
                        <b-card-title class="mb-25">
                          {{ $t('DEBTIA_DEBT_REMINDER') }}
                        </b-card-title>
                        <b-card-text class="mb-0">
                          {{ $t('DEBTIA_ADD_DEBT_REMINDER') }}
                        </b-card-text>
                      </div>
                      <div class="meetup-day meetup-day-1">
                        <b-button
                          v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                          variant="outline-primary"
                          class="btn-icon rounded-circle"
                          @click="addDebtReminders"
                        >
                          <feather-icon icon="PlusIcon" />
                        </b-button>
                      </div>
                    </div>
                    <!--/ metting header -->

                  </b-card-body>
                </b-col>
              </b-row>
              <b-row>
                <b-table
                  v-if="debtReminderitems.length > 0"
                  ref="innertable"
                  class="position-relative modal-table baseDocumentTable"
                  :no-border-collapse="noCollapse"
                  sticky-header="360px"
                  responsive
                  :fields="tableFields"
                  :items="debtReminderitems"
                  primary-key="index"
                  hover
                >
                  <template #table-colgroup="scope">
                    <col
                      v-for="field in scope.fields"
                      :key="field.key"
                      :style="{ width: field.key === 'details' || field.key === 'removeRecord' ? '15px' : '' }"
                    >
                  </template>
                  <template
                    #cell(removeRecord)="data"
                  >
                    <div class="demo-inline-spacing">
                      <b-button
                        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                        variant="warning"
                        class="btn-icon margin-top-zero margin-right-ten delete-record"
                        @click="removeItem('debtreminders', data.item.index)"
                      >
                        <feather-icon icon="XIcon" />
                      </b-button>
                    </div>
                  </template>
                  <template
                    #cell(details)="data"
                  >
                    <div class="demo-inline-spacing">
                      <b-button
                        :id="'debtreminders-btn-'+data.item.index"
                        v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                        variant="outline-primary"
                        class="btn-icon margin-top-zero margin-right-zero"
                        @click="openDetails('debtreminders', data)"
                      >
                        <feather-icon :icon="data.detailsShowing ? 'ChevronUpIcon' : 'ChevronDownIcon'" />
                      </b-button>
                    </div>
                  </template>
                  <template #row-details="data">
                    <b-card>
                      <b-row class="mb-2">
                        <b-col
                          sm="10"
                          offset-sm="1"
                        >
                          <b-row class="mb-2">
                            <b-col
                              :id="'debtreminders-file-div-'+data.item.index"
                              sm="12"
                            >
                              <b-form-file
                                :id="'debtreminders-file-'+data.item.index"
                                :ref="'debtreminders-file-'+data.item.index"
                                @change="validateFile('debtreminders', $event, data.item.index)"
                              />
                              <label
                                :for="'debtreminders-file-'+data.item.index"
                                data-browse="Browse"
                                class="custom-file-label"
                              ><span
                                :id="'debtreminders-file-span-'+data.item.index"
                                class="d-block form-file-text"
                                style="pointer-events: none;"
                              >No File Selected</span></label>
                            </b-col>
                            <b-col
                              sm="12"
                              class="mt-1"
                            >
                              <b-input-group
                                :prepend="$t('DEBTIA_DOCUMENT_DATE')+'*'"
                              >
                                <cleave
                                  id="date"
                                  v-model="data.item.fullData.daDocumentDate"
                                  class="form-control"
                                  :raw="false"
                                  :options="options.date"
                                  placeholder="DD-MM-YYYY"
                                  @input="validateDate('debtreminders', 'documentdateerror', data.item.index, data.item.fullData, 'daDocumentDate', 'documentDate'), dueDateValidity('debtreminders', data.item.index, data.item.fullData), wizardFieldChange('debtreminders', data.item.index)"
                                />
                                <b-input-group-append>
                                  <b-form-datepicker
                                    v-model="data.item.fullData.documentDate"
                                    :date-format-options="{ day: 'numeric', month: 'numeric', year: 'numeric' }"
                                    trim
                                    button-only
                                    right
                                    size="sm"
                                    @input="dueDateValidity('debtreminders', data.item.index, data.item.fullData), wizardFieldChange('debtreminders', data.item.index), assignDateValue($event, data.item.fullData, 'daDocumentDate')"
                                  />
                                </b-input-group-append>
                              </b-input-group>
                              <label
                                :id="'debtreminders-documentdateerror-'+data.item.index"
                                style="color: red; display:none;"
                              >*{{ $t('DEBTIA_DATE_FORMAT_ERROR') }}</label>
                            </b-col>
                            <b-col
                              sm="12"
                              class="mt-1"
                            >
                              <b-input-group
                                :prepend="$t('DEBTIA_DUE_DATE')+'*'"
                              >
                                <cleave
                                  id="date"
                                  v-model="data.item.fullData.daDueDate"
                                  class="form-control"
                                  :raw="false"
                                  :options="options.date"
                                  placeholder="DD-MM-YYYY"
                                  @input="validateDate('debtreminders', 'duedateformaterror', data.item.index, data.item.fullData, 'daDueDate', 'dueDate'), dueDateValidity('debtreminders', data.item.index, data.item.fullData), wizardFieldChange('debtreminders', data.item.index)"
                                />
                                <b-input-group-append>
                                  <b-form-datepicker
                                    v-model="data.item.fullData.dueDate"
                                    :date-format-options="{ day: 'numeric', month: 'numeric', year: 'numeric' }"
                                    trim
                                    button-only
                                    right
                                    size="sm"
                                    @input="dueDateValidity('debtreminders', data.item.index, data.item.fullData), wizardFieldChange('debtreminders', data.item.index), assignDateValue($event, data.item.fullData, 'daDueDate')"
                                  />
                                </b-input-group-append>
                              </b-input-group>
                              <label
                                :id="'debtreminders-duedateerror-'+data.item.index"
                                style="color: red; display:none;"
                              >*{{ $t('DEBTIA_DUEDATE_LESSER_ERROR') }}</label>
                              <label
                                :id="'debtreminders-duedateformaterror-'+data.item.index"
                                style="color: red; display:none;"
                              >*{{ $t('DEBTIA_DATE_FORMAT_ERROR') }}</label>
                            </b-col>
                            <b-col
                              sm="12"
                              class="mt-1"
                            >
                              <b-input-group
                                :prepend="$t('DEBTIA_REMINDER_FEE')"
                                :append="defaultCurrencySymbol"
                              >
                                <b-form-input
                                  v-model="data.item.fullData.reminderFee"
                                  type="number"
                                  @change="wizardFieldChange('debtreminders', data.item.index)"
                                />
                              </b-input-group>
                            </b-col>
                            <b-col
                              sm="12"
                              class="mt-1"
                            >
                              <b-input-group
                                :prepend="$t('DEBTIA_COMPENSATION_FEE')"
                                :append="defaultCurrencySymbol"
                              >
                                <b-form-input
                                  v-if="activeOption !== 1"
                                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                                  v-b-tooltip.hover.bottom="$t('DEBTIA_BASETYPE_INVOICE_TEXT')"
                                  value="0"
                                  readonly
                                />
                                <b-form-input
                                  v-else
                                  v-model="data.item.fullData.compensationFee"
                                  type="number"
                                  @change="wizardFieldChange('debtreminders', data.item.index)"
                                />
                              </b-input-group>
                            </b-col>
                          </b-row>
                          <b-button
                            size="sm"
                            @click="data.toggleDetails"
                          >
                            {{ $t('DEBTIA_HIDE_DETAILS') }}</b-button>
                        </b-col>
                      </b-row>
                    </b-card>
                  </template>
                </b-table>
                <div
                  v-else
                  class="demo-spacing-0 creditnotesalert"
                >
                  <b-alert
                    variant="primary"
                    show
                  >
                    <div class="alert-body">
                      <span>{{ $t('DEBTIA_NO_DEBT_REMINDER_MSG') }}</span>
                    </div>
                  </b-alert>
                </div>
              </b-row>
            </tab-content>
          </keep-alive>
          <!-- social link -->
          <keep-alive>
            <tab-content
              :title="$t('DEBTIA_OTHER_FILES')"
              :before-change="stepfive"
            >
              <b-row
                class="border-bottom"
              >
                <b-col
                  cols="12"
                  class="base-doc"
                >
                  <b-card-body>
                    <!-- metting header -->
                    <div class="meetup-header align-items-center">
                      <div class="my-auto my-auto-1">
                        <b-card-title class="mb-25">
                          {{ $t('DEBTIA_OTHER_FILES') }}
                        </b-card-title>
                        <b-card-text class="mb-0">
                          {{ $t('DEBTIA_ADD_OTHER_FILES') }}
                        </b-card-text>
                      </div>
                      <div class="meetup-day meetup-day-1">
                        <b-button
                          v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                          variant="outline-primary"
                          class="btn-icon rounded-circle"
                          @click="addOtherFiles"
                        >
                          <feather-icon icon="PlusIcon" />
                        </b-button>
                      </div>
                    </div>
                    <!--/ metting header -->

                  </b-card-body>
                </b-col>
              </b-row>
              <b-row>
                <b-table
                  v-if="otherFilesitems.length > 0"
                  ref="innertable"
                  class="position-relative modal-table baseDocumentTable"
                  :no-border-collapse="noCollapse"
                  sticky-header="360px"
                  responsive
                  :fields="tableFields"
                  :items="otherFilesitems"
                  primary-key="index"
                  hover
                >
                  <template #table-colgroup="scope">
                    <col
                      v-for="field in scope.fields"
                      :key="field.key"
                      :style="{ width: field.key === 'details' || field.key === 'removeRecord' ? '15px' : '' }"
                    >
                  </template>
                  <template
                    #cell(removeRecord)="data"
                  >
                    <div class="demo-inline-spacing">
                      <b-button
                        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                        variant="warning"
                        class="btn-icon margin-top-zero margin-right-ten delete-record"
                        @click="removeItem('otherfiles', data.item.index)"
                      >
                        <feather-icon icon="XIcon" />
                      </b-button>
                    </div>
                  </template>
                  <template
                    #cell(details)="data"
                  >
                    <div class="demo-inline-spacing">
                      <b-button
                        :id="'otherfiles-btn-'+data.item.index"
                        v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                        variant="outline-primary"
                        class="btn-icon margin-top-zero margin-right-zero"
                        @click="openDetails('otherfiles', data)"
                      >
                        <feather-icon :icon="data.detailsShowing ? 'ChevronUpIcon' : 'ChevronDownIcon'" />
                      </b-button>
                    </div>
                  </template>
                  <template #row-details="data">
                    <b-card>
                      <b-row class="mb-2">
                        <b-col
                          sm="10"
                          offset-sm="1"
                        >
                          <b-row class="mb-2">
                            <b-col
                              :id="'otherfiles-file-div-'+data.item.index"
                              sm="12"
                            >
                              <b-form-file
                                :id="'otherfiles-file-'+data.item.index"
                                :ref="'otherfiles-file-'+data.item.index"
                                @change="validateFile('otherfiles', $event, data.item.index)"
                              />
                              <label
                                :for="'otherfiles-file-'+data.item.index"
                                data-browse="Browse"
                                class="custom-file-label"
                              ><span
                                :id="'otherfiles-file-span-'+data.item.index"
                                class="d-block form-file-text"
                                style="pointer-events: none;"
                              >No File Selected</span></label>
                            </b-col>
                            <b-col
                              sm="12"
                              class="mt-1"
                            >
                              <b-input-group
                                :prepend="$t('DEBTIA_CATEGORY')"
                              >
                                <v-select
                                  v-model="data.item.fullData.category_id"
                                  class="otherfiles_category_id"
                                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                  :options="categoryOptions"
                                  :reduce="val => val.value"
                                  :clearable="false"
                                  input-id="otherfiles_category_id"
                                />
                              </b-input-group>
                            </b-col>
                            <b-col
                              sm="12"
                              class="mt-1"
                            >
                              <b-input-group
                                :prepend="$t('DEBTIA_TITLE')+'*'"
                              >
                                <b-form-input
                                  :id="'otherfiles_'+data.item.index+'_title'"
                                  v-model="data.item.fullData.title"
                                  @change="wizardFieldChange('otherfiles', data.item.index)"
                                />
                              </b-input-group>
                            </b-col>
                          </b-row>
                          <b-button
                            size="sm"
                            @click="data.toggleDetails"
                          >
                            {{ $t('DEBTIA_HIDE_DETAILS') }}</b-button>
                        </b-col>
                      </b-row>
                    </b-card>
                  </template>
                </b-table>
                <div
                  v-else
                  class="demo-spacing-0 creditnotesalert"
                >
                  <b-alert
                    variant="primary"
                    show
                  >
                    <div class="alert-body">
                      <span>{{ $t('DEBTIA_NO_OTHER_FILES_MSG') }}</span>
                    </div>
                  </b-alert>
                </div>
              </b-row>
            </tab-content>
          </keep-alive>
          <!-- Custom Variables -->
          <!-- social link -->
          <keep-alive>
            <tab-content
              v-if="customVariables.length > 0"
              :title="$t('DEBTIA_GENERAL_INFORMATION')"
              :before-change="generalstep"
            >
              <b-row
                class="border-bottom"
              >
                <b-col
                  cols="12"
                  class="base-doc"
                >
                  <b-card-body>
                    <!-- metting header -->
                    <div class="meetup-header align-items-center">
                      <div class="my-auto my-auto-1">
                        <b-card-title class="mb-25">
                          {{ $t('DEBTIA_GENERAL_INFORMATION') }}
                        </b-card-title>
                        <b-card-text class="mb-0">
                          {{ $t('DEBTIA_ADD_GENERAL_INFORMATION') }}
                        </b-card-text>
                      </div>
                    </div>
                    <!--/ metting header -->

                  </b-card-body>
                </b-col>
              </b-row>
              <b-card-body
                class="custom-variables-body"
              >
                <b-row>
                  <b-col
                    v-for="variable in customVariables"
                    :key="variable.id"
                    cols="12"
                  >
                    <div v-if="variable.display_in_add_edit_page === 1 || variable.display_in_add_edit_page === true">
                      <b-form-group
                        :label="$t(variable.variable)"
                        label-for="h-first-name"
                        label-cols-md="12"
                        label-cols="12"
                      >
                        <time-field
                          v-if="variable.type === 'time'"
                          :ref="`time-ref-${variable.id}`"
                          :field-id="variable.id"
                          :field-variable="variable.variable"
                          :time-field-check="timeFieldCheck"
                        />
                        <b-input-group
                          v-else-if="variable.type === 'date'"
                        >
                          <cleave
                            id="date"
                            v-model="caseGeneralDates[`da${variable.variable}`]"
                            class="form-control"
                            :raw="false"
                            :options="options.date"
                            placeholder="DD-MM-YYYY"
                            @input="customVariableChange(normalToDa($event), variable.variable, variable.id), validateDate('general_custom_fields', 'dateerror', variable.id, caseGeneralDates, `da${variable.variable}`, variable.variable)"
                          />
                          <b-input-group-append>
                            <b-form-datepicker
                              v-model="caseGeneralDates[variable.variable]"
                              :date-format-options="{ day: 'numeric', month: 'numeric', year: 'numeric' }"
                              trim
                              button-only
                              right
                              size="sm"
                              @input="customVariableChange($event, variable.variable, variable.id), assignDateValue($event, caseGeneralDates, `da${variable.variable}`)"
                            />
                          </b-input-group-append>
                        </b-input-group>
                        <b-form-textarea
                          v-else-if="variable.type === 'multiline string'"
                          id="textarea-rows"
                          :placeholder="$t(variable.variable)"
                          rows="3"
                          @change="customVariableChange($event, variable.variable, variable.id)"
                        />
                        <v-select
                          v-else-if="variable.type === 'select'"
                          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                          :options="variable.options.length > 0 ? variable.options : airportOptions"
                          :reduce="val => val.value"
                          :clearable="false"
                          input-id="debtor-login-status"
                          @input="customVariableChange($event, variable.variable, variable.id)"
                        />
                        <b-form-radio-group
                          v-else-if="variable.type === 'boolean'"
                          :options="radioOptions"
                          value-field="item"
                          text-field="name"
                          disabled-field="notEnabled"
                          class="demo-inline-spacing"
                          @change="customVariableChange($event, variable.variable, variable.id)"
                        />
                        <b-form-input
                          v-else-if="variable.type === 'number'"
                          type="number"
                          :placeholder="$t(variable.variable)"
                          @change="customVariableChange($event, variable.variable, variable.id)"
                        />
                        <b-form-input
                          v-else
                          id="h-first-name"
                          :placeholder="$t(variable.variable)"
                          @change="customVariableChange($event, variable.variable, variable.id)"
                        />
                        <small
                          :id="'text-danger-'+variable.id"
                          class="noShow"
                        >Field {{ $t(variable.variable) }} is required.</small>
                        <label
                          :id="'general_custom_fields-dateerror-'+variable.id"
                          style="color: red; display:none;"
                        >*{{ $t('DEBTIA_DATE_FORMAT_ERROR') }}</label>
                      </b-form-group>
                    </div>
                  </b-col>
                </b-row>
              </b-card-body>
            </tab-content>
          </keep-alive>
          <!-- /Custom Variables -->
          <!-- social link -->
          <keep-alive>
            <tab-content
              :title="$t('DEBTIA_DEBTORS')"
              :before-change="runStepSix"
            >
              <b-row
                class="border-bottom"
              >
                <b-col
                  cols="12"
                  class="base-doc"
                >
                  <b-card-body>
                    <!-- metting header -->
                    <div class="meetup-header align-items-center">
                      <div class="my-auto my-auto-1">
                        <b-card-title class="mb-25">
                          {{ $t('DEBTIA_DEBTORS') }}
                        </b-card-title>
                        <b-card-text class="mb-0">
                          {{ $t('DEBTIA_ADD_DEBTORS') }}
                        </b-card-text>
                      </div>
                      <div class="meetup-day meetup-day-1">
                        <b-button
                          v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                          variant="outline-primary"
                          class="btn-icon rounded-circle"
                          @click="addDebtor"
                        >
                          <feather-icon icon="PlusIcon" />
                        </b-button>
                      </div>
                    </div>
                    <!--/ metting header -->

                  </b-card-body>
                </b-col>
              </b-row>
              <b-row>
                <b-table
                  ref="innertable"
                  class="position-relative modal-table debtorsTable"
                  :no-border-collapse="noCollapse"
                  sticky-header="360px"
                  responsive
                  :fields="tableFields"
                  :items="debtorsitems"
                  primary-key="index"
                  hover
                >
                  <template #table-colgroup="scope">
                    <col
                      v-for="field in scope.fields"
                      :key="field.key"
                      :style="{ width: field.key === 'details' || field.key === 'removeRecord' ? '15px' : '' }"
                    >
                  </template>
                  <template
                    #cell(removeRecord)="data"
                  >
                    <div class="demo-inline-spacing">
                      <b-button
                        v-if="data.item.index !== 1"
                        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                        variant="warning"
                        class="btn-icon margin-top-zero margin-right-ten delete-record"
                        @click="removeItem('debtors', data.item.index)"
                      >
                        <feather-icon icon="XIcon" />
                      </b-button>
                    </div>
                  </template>
                  <template
                    #cell(details)="data"
                  >
                    <div class="demo-inline-spacing">
                      <b-button
                        :id="'debtors-btn-'+data.item.index"
                        v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                        variant="outline-primary"
                        class="btn-icon margin-top-zero margin-right-zero"
                        @click="openDetails('debtors', data)"
                      >
                        <feather-icon :icon="data.detailsShowing ? 'ChevronUpIcon' : 'ChevronDownIcon'" />
                      </b-button>
                    </div>
                  </template>
                  <template #row-details="data">
                    <b-card>
                      <b-row
                        class="debtor-row"
                      >
                        <b-col
                          cols="12"
                          md="12"
                          class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
                        >
                          <label
                            class="debtor-label"
                          ><h6>{{ $t('DEBTIA_DEBTOR') }}</h6></label>
                          <v-select
                            v-model="data.item.fullData.debtorID"
                            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                            class="debtors-select"
                            :options="clientDebtors"
                            :reduce="val => val.value"
                            :clearable="false"
                            input-id="debtors-list"
                            @input="getDebtorDetails(data.item.index, data.item.fullData.debtorID)"
                          />
                        </b-col>
                      </b-row>
                      <b-row
                        class="debtor-creds-row"
                      >
                        <b-col md="12">
                          <b-alert
                            variant="warning"
                            show
                          >
                            <div class="alert-body">
                              {{ $t('DEBTIA_REQUIRED_FIELD_MSG') }}
                            </div>
                          </b-alert>
                        </b-col>
                        <b-col
                          :id="'col-debtor-username-'+data.item.index"
                          md="6"
                        >
                          <b-form-group
                            :label="$t('DEBTIA_USER_NAME')+'*'"
                            label-for="debtor-username"
                          >
                            <b-form-input
                              :id="'debtor-username-'+data.item.index"
                              v-model="data.item.fullData.username.value"
                              :readonly="debtorsBelongToCompany"
                              @change="validateUserName($event,data.item.index), checkRequiredField(`debtor-username-${data.item.index}`, $event)"
                            />
                            <label
                              :id="'usernameerror-'+data.item.index"
                              style="color: red; display:none;"
                            >*{{ $t('DEBTIA_USERNAME_EXISTS') }}</label>
                          </b-form-group>
                        </b-col>
                        <b-col
                          :id="'col-debtor-password-'+data.item.index"
                          md="6"
                          v-bind="[data.item.fullData.password.required ? '' : debtorPassword, '']"
                        >
                          <b-form-group
                            :label="$t('DEBTIA_PASSWORD')+'*'"
                            label-for="debtor-password"
                          >
                            <b-input-group>
                              <b-form-input
                                :id="'debtor-password-'+data.item.index"
                                v-model="data.item.fullData.password.value"
                                :type="passwordFieldType"
                                :readonly="debtorsBelongToCompany"
                                @change="wizardFieldChange('debtors', data.item.index), checkRequiredField(`debtor-password-${data.item.index}`, $event)"
                              />
                              <b-input-group-append is-text>
                                <feather-icon
                                  :icon="passwordToggleIcon"
                                  class="cursor-pointer"
                                  @click="togglePasswordVisibility"
                                />
                              </b-input-group-append>
                            </b-input-group>
                          </b-form-group>
                        </b-col>
                        <b-col
                          :id="'col-debtor-loginStatus-'+data.item.index"
                          md="6"
                        >
                          <b-form-group
                            :label="$t('DEBTIA_LOGIN_STATUS')+'*'"
                            label-for="debtor-login-status"
                          >
                            <v-select
                              v-model="data.item.fullData.loginStatus.value"
                              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                              :options="loginOptions"
                              :reduce="val => val.value"
                              :clearable="false"
                              :input-id="'debtor-loginStatus-'+data.item.index"
                              :disabled="debtorsBelongToCompany"
                              @input="wizardFieldChange('debtors', data.item.index), checkRequiredDropdown(`debtor-loginStatus-${data.item.index}`)"
                            />
                          </b-form-group>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col
                          :id="'col-debtor-name-'+data.item.index"
                          md="6"
                        >
                          <b-form-group
                            :label="$t('DEBTIA_FULL_NAME')+'*'"
                            label-for="debtor-name"
                          >
                            <b-form-input
                              :id="'debtor-name-'+data.item.index"
                              v-model="data.item.fullData.name.value"
                              :readonly="debtorsBelongToCompany"
                              @change="wizardFieldChange('debtors', data.item.index), checkRequiredField(`debtor-name-${data.item.index}`, $event)"
                            />
                          </b-form-group>
                        </b-col>
                        <b-col
                          :id="'col-debtor-co-'+data.item.index"
                          md="6"
                        >
                          <b-form-group
                            label="C/O"
                            label-for="debtor-co"
                          >
                            <b-form-input
                              :id="'debtor-co-'+data.item.index"
                              v-model="data.item.fullData.co.value"
                              :readonly="debtorsBelongToCompany"
                              @change="wizardFieldChange('debtors', data.item.index)"
                            />
                          </b-form-group>
                        </b-col>
                        <b-col
                          :id="'col-debtor-cpn-'+data.item.index"
                          md="6"
                        >
                          <b-form-group
                            :label="$t('DEBTIA_CONTACT_PERSON_NAME')"
                            label-for="debtor-cpn"
                          >
                            <b-form-input
                              :id="'debtor-cpn-'+data.item.index"
                              v-model="data.item.fullData.cpn.value"
                              :readonly="debtorsBelongToCompany"
                              @change="wizardFieldChange('debtors', data.item.index)"
                            />
                          </b-form-group>
                        </b-col>
                        <b-col
                          :id="'col-debtor-debtortype-'+data.item.index"
                          md="6"
                        >
                          <b-form-group
                            :label="$t('DEBTIA_DEBTOR_TYPE')+'*'"
                            label-for="debtor-type"
                          >
                            <v-select
                              v-model="data.item.fullData.debtortype.value"
                              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                              :options="debtorTypeOptions"
                              :reduce="val => val.value"
                              :clearable="false"
                              :input-id="'debtor-debtortype-'+data.item.index"
                              :disabled="debtorsBelongToCompany"
                              @input="wizardFieldChange('debtors', data.item.index), debtorTypeChanged($event,data.item.index), checkRequiredDropdown(`debtor-debtortype-${data.item.index}`)"
                            />
                          </b-form-group>
                        </b-col>
                        <b-col
                          v-if="data.item.fullData.debtortype.value && data.item.fullData.debtortype.value === 'person'"
                          :id="'col-debtor-cpr-'+data.item.index"
                          md="6"
                        >
                          <b-form-group
                            :label="$t('DEBTIA_CPR')"
                            label-for="debtor-cpr"
                          >
                            <div class="form-label-group">
                              <cleave
                                :id="'debtor-cpr-'+data.item.index"
                                v-model="data.item.fullData.cpr.value"
                                class="form-control"
                                :raw="false"
                                :options="options.cprDelimiter"
                                :readonly="debtorsBelongToCompany"
                                @input="wizardFieldChange('debtors', data.item.index)"
                              />
                            </div>
                          </b-form-group>
                        </b-col>
                        <b-col
                          v-if="data.item.fullData.debtortype.value && data.item.fullData.debtortype.value !== 'person'"
                          :id="'col-debtor-cvrnumber-'+data.item.index"
                          md="6"
                        >
                          <b-form-group
                            label-for="debtor-cvrnumber"
                            label="CVR"
                          >
                            <div class="form-label-group margin-btm">
                              <b-form-input
                                :id="'debtor-cvrnumber-'+data.item.index"
                                v-model="data.item.fullData.cvrnumber.value"
                                type="number"
                                :readonly="debtorsBelongToCompany"
                                @change="wizardFieldChange('debtors', data.item.index), cvrChecker($event, data.item.index)"
                              />
                            </div>
                            <label
                              :id="'debtor-cvr-error-'+data.item.index"
                              class="cvr-error cvr-error-hide"
                            >{{ $t('DEBTIA_CVR_LENGTH_MSG') }}</label>
                          </b-form-group>
                        </b-col>
                        <b-col
                          :id="'col-debtor-phone-'+data.item.index"
                          md="6"
                        >
                          <b-form-group
                            :label="$t('DEBTIA_PHONE_NUMBER')"
                            label-for="debtor-phonenumber"
                          >
                            <div class="form-label-group">
                              <b-form-input
                                :id="'debtor-phone-'+data.item.index"
                                v-model="data.item.fullData.phone.value"
                                :readonly="debtorsBelongToCompany"
                                @change="wizardFieldChange('debtors', data.item.index)"
                              />
                            </div>
                          </b-form-group>
                        </b-col>
                        <b-col
                          :id="'col-debtor-email-'+data.item.index"
                          md="6"
                        >
                          <b-form-group
                            label-for="debtor-email"
                            :label="$t('DEBTIA_EMAIL')"
                          >
                            <div class="form-label-group">
                              <b-form-input
                                :id="'debtor-email-'+data.item.index"
                                v-model="data.item.fullData.email.value"
                                type="email"
                                placeholder="Email"
                                :readonly="debtorsBelongToCompany"
                                @change="wizardFieldChange('debtors', data.item.index)"
                              />
                            </div>
                          </b-form-group>
                        </b-col>
                        <b-col
                          md="12"
                          xl="12"
                        >
                          <b-card
                            :title="$t('DEBTIA_BANK_INFORMATION')"
                            bg-variant="transparent"
                            class="shadow-none address-section"
                          >
                            <b-row>
                              <b-col
                                :id="'col-debtor-bank_account_no-'+data.item.index"
                                md="6"
                              >
                                <b-form-group
                                  :label="$t('BANK_ACCOUNT_NO')"
                                  label-for="debtor-bank-account-no"
                                >
                                  <div class="form-label-group">
                                    <b-form-input
                                      :id="'debtor-bank_account_no-'+data.item.index"
                                      v-model="data.item.fullData.bank_account_no.value"
                                      :readonly="debtorsBelongToCompany"
                                      @change="wizardFieldChange('debtors', data.item.index)"
                                    />
                                  </div>
                                </b-form-group>
                              </b-col>
                              <b-col
                                :id="'col-debtor-bank_branch_no-'+data.item.index"
                                md="6"
                              >
                                <b-form-group
                                  :label="$t('DEBTIA_BANK_BRANCH_NO')"
                                  label-for="debtor-bank_branch_no"
                                >
                                  <div class="form-label-group">
                                    <b-form-input
                                      :id="'debtor-bank_branch_no-'+data.item.index"
                                      v-model="data.item.fullData.bank_branch_no.value"
                                      :readonly="debtorsBelongToCompany"
                                      @change="wizardFieldChange('debtors', data.item.index)"
                                    />
                                  </div>
                                </b-form-group>
                              </b-col>
                            </b-row>
                          </b-card>
                        </b-col>
                        <b-col
                          md="12"
                          xl="12"
                        >
                          <b-card
                            :title="$t('DEBTIA_ADDRESS')"
                            bg-variant="transparent"
                            class="shadow-none address-section"
                          >
                            <b-row>
                              <b-col
                                :id="'col-debtor-road_name-'+data.item.index"
                                md="6"
                              >
                                <b-form-group
                                  label="Street Name*"
                                  label-for="debtor-street"
                                >
                                  <div class="form-label-group">
                                    <b-form-input
                                      :id="'debtor-road_name-'+data.item.index"
                                      v-model="data.item.fullData.address.road_name.value"
                                      :readonly="debtorsBelongToCompany || data.item.fullData.hide_address"
                                      @change="wizardFieldChange('debtors', data.item.index), checkRequiredField(`debtor-road_name-${data.item.index}`, $event)"
                                    />
                                  </div>
                                </b-form-group>
                              </b-col>
                              <b-col
                                :id="'col-debtor-house_number-'+data.item.index"
                                md="6"
                              >
                                <b-form-group
                                  :label="$t('DEBTIA_HOUSE_NUMBER')+'*'"
                                  label-for="debtor-house-number"
                                >
                                  <div class="form-label-group">
                                    <b-form-input
                                      :id="'debtor-house_number-'+data.item.index"
                                      v-model="data.item.fullData.address.house_number.value"
                                      :readonly="debtorsBelongToCompany || data.item.fullData.hide_address"
                                      @change="wizardFieldChange('debtors', data.item.index), checkRequiredField(`debtor-house_number-${data.item.index}`, $event)"
                                    />
                                  </div>
                                </b-form-group>
                              </b-col>
                              <b-col
                                :id="'col-debtor-place-'+data.item.index"
                                md="6"
                              >
                                <b-form-group
                                  :label="$t('DEBTIA_PLACE')"
                                  label-for="debtor-place"
                                >
                                  <div class="form-label-group">
                                    <b-form-input
                                      :id="'debtor-place-'+data.item.index"
                                      v-model="data.item.fullData.address.place.value"
                                      :readonly="debtorsBelongToCompany || data.item.fullData.hide_address"
                                      @change="wizardFieldChange('debtors', data.item.index), checkRequiredField(`debtor-place-${data.item.index}`, $event)"
                                    />
                                  </div>
                                </b-form-group>
                              </b-col>
                              <b-col
                                :id="'col-debtor-zip_code-'+data.item.index"
                                md="6"
                              >
                                <b-form-group
                                  :label="$t('DEBTIA_ZIP_CODE')+'*'"
                                  label-for="debtor-zipcode"
                                >
                                  <div class="form-label-group">
                                    <b-form-input
                                      :id="'debtor-zip_code-'+data.item.index"
                                      v-model="data.item.fullData.address.zip_code.value"
                                      :readonly="debtorsBelongToCompany || data.item.fullData.hide_address"
                                      @change="wizardFieldChange('debtors', data.item.index), getCityNCourtName($event, data.item.index), checkRequiredField(`debtor-zip_code-${data.item.index}`, $event)"
                                    />
                                  </div>
                                </b-form-group>
                              </b-col>
                              <b-col
                                :id="'col-debtor-court-'+data.item.index"
                                md="6"
                              >
                                <b-form-group
                                  :label="$t('DEBTIA_COURT')"
                                  label-for="debtor-court"
                                >
                                  <div class="form-label-group">
                                    <v-select
                                      v-model="data.item.fullData.address.court_id.value"
                                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                      :options="courts"
                                      :reduce="val => val.value"
                                      :clearable="false"
                                      :input-id="'debtor-court-'+data.item.index"
                                      :disabled="debtorsBelongToCompany || data.item.fullData.hide_address"
                                      @change="wizardFieldChange('debtors', data.item.index)"
                                    />
                                  </div>
                                </b-form-group>
                              </b-col>
                              <b-col
                                :id="'col-debtor-city-'+data.item.index"
                                md="6"
                              >
                                <b-form-group
                                  :label="$t('DEBTIA_CITY')+'*'"
                                  label-for="debtor-city"
                                >
                                  <div class="form-label-group">
                                    <b-form-input
                                      :id="'debtor-city-'+data.item.index"
                                      v-model="data.item.fullData.address.city.value"
                                      :readonly="debtorsBelongToCompany || data.item.fullData.hide_address"
                                      @change="wizardFieldChange('debtors', data.item.index), getZipcode($event, data.item.index), checkRequiredField(`debtor-city-${data.item.index}`, $event)"
                                    />
                                  </div>
                                </b-form-group>
                              </b-col>
                              <b-col
                                :id="'col-debtor-country-'+data.item.index"
                                md="6"
                              >
                                <b-form-group
                                  :label="$t('DEBTIA_COUNTRY')+'*'"
                                  label-for="debtor-country"
                                >
                                  <div class="form-label-group">
                                    <v-select
                                      :id="'debtor-country-'+data.item.index"
                                      v-model="data.item.fullData.address.country_id.value"
                                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                      :options="countries"
                                      :reduce="val => val.value"
                                      :clearable="false"
                                      input-id="select-country"
                                      :value="'Select Country'"
                                      :disabled="debtorsBelongToCompany || data.item.fullData.hide_address"
                                      @change="wizardFieldChange('debtors', data.item.index)"
                                      @input="val => onCountryChange(val, data.item)"
                                    >
                                      <template
                                        #selected-option-container="{ option }"
                                      >
                                        <div class="vs__selected">
                                          {{ $t(option.label) }}</div>
                                      </template>
                                      <template
                                        slot="option"
                                        slot-scope="option"
                                      >
                                        {{ $t(option.label) }}
                                      </template>
                                    </v-select>
                                  </div>
                                </b-form-group>
                              </b-col>
                            </b-row>
                          </b-card>
                        </b-col>
                        <b-col
                          v-if="debtorCustomVariables.length > 0"
                          md="12"
                          xl="12"
                        >
                          <b-card
                            :title="$t('DEBTIA_GENERAL_INFORMATION')"
                            bg-variant="transparent"
                            class="shadow-none address-section"
                          >
                            <b-row>
                              <input
                                hidden
                                :value="debtorReactiveVar"
                              >
                              <b-col
                                v-for="(variable, varIndex) in debtorCustomVariables"
                                :id="'col-debtor-'+variable.variable+'-'+data.item.index"
                                :key="variable.id"
                                offset-sm="2"
                                cols="8"
                              >
                                <div v-if="variable.display_in_add_edit_page === 1 || variable.display_in_add_edit_page === true">
                                  <b-form-group
                                    :label="variable.is_required ? $t(variable.variable)+'*' : $t(variable.variable)"
                                    :label-for="'debtor-'+variable.variable+'-'+data.item.index"
                                    label-cols-md="4"
                                  >

                                    <vue-timepicker
                                      v-if="variable.type === 'time'"
                                      :id="'debtor-'+variable.variable+'-'+data.item.index"
                                      v-model="data.item.fullData.variables[varIndex].value"
                                      class="timepicker"
                                      :disabled="debtorsBelongToCompany"
                                      @change="wizardFieldChange('debtors', data.item.index), checkRequiredField(`debtor-${variable.variable}-${data.item.index}`, $event)"
                                    />
                                    <b-input-group
                                      v-else-if="variable.type === 'date'"
                                    >
                                      <cleave
                                        :id="'debtor-'+variable.variable+'-'+data.item.index"
                                        v-model="data.item.fullData.debtorGeneralDates[`da${variable.variable}`]"
                                        class="form-control"
                                        :raw="false"
                                        :options="options.date"
                                        placeholder="DD-MM-YYYY"
                                        @input="checkRequiredField(`debtor-${variable.variable}-${data.item.index}`, $event), validateDate('debtor_custom_fields', 'dateerror', variable.variable, data.item.fullData.debtorGeneralDates, `da${variable.variable}`, variable.variable), assignValue('debtors', data.item.index, varIndex, $event), wizardFieldChange('debtors', data.item.index)"
                                      />
                                      <b-input-group-append>
                                        <b-form-datepicker
                                          :id="'debtor-'+variable.variable+'-'+data.item.index"
                                          v-model="data.item.fullData.debtorGeneralDates[variable.variable]"
                                          :date-format-options="{ day: 'numeric', month: 'numeric', year: 'numeric' }"
                                          :disabled="debtorsBelongToCompany"
                                          trim
                                          button-only
                                          right
                                          size="sm"
                                          @input="checkRequiredField(`debtor-${variable.variable}-${data.item.index}`, $event), assignDateValue($event, data.item.fullData.debtorGeneralDates, `da${variable.variable}`), wizardFieldChange('debtors', data.item.index)"
                                        />
                                      </b-input-group-append>
                                    </b-input-group>
                                    <b-form-textarea
                                      v-else-if="variable.type === 'multiline string'"
                                      :id="'debtor-'+variable.variable+'-'+data.item.index"
                                      v-model="data.item.fullData.variables[varIndex].value"
                                      :placeholder="$t(variable.variable)"
                                      rows="3"
                                      :readonly="debtorsBelongToCompany"
                                      @change="wizardFieldChange('debtors', data.item.index), checkRequiredField(`debtor-${variable.variable}-${data.item.index}`, $event)"
                                    />
                                    <v-select
                                      v-else-if="variable.type === 'select'"
                                      v-model="data.item.fullData.variables[varIndex].value"
                                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                      :options="variable.options.length > 0 ? variable.options : airportOptions"
                                      :reduce="val => val.value"
                                      :clearable="false"
                                      :input-id="'debtor-'+variable.variable+'-'+data.item.index"
                                      :disabled="debtorsBelongToCompany"
                                      @input="customReactiveVar(data.item.index), checkRequiredDropdown(`debtor-${variable.variable}-${data.item.index}`)"
                                    />
                                    <b-form-radio-group
                                      v-else-if="variable.type === 'boolean'"
                                      :id="'debtor-'+variable.variable+'-'+data.item.index"
                                      v-model="data.item.fullData.variables[varIndex].value"
                                      :options="radioOptions"
                                      value-field="item"
                                      text-field="name"
                                      disabled-field="notEnabled"
                                      class="demo-inline-spacing"
                                      :disabled="debtorsBelongToCompany"
                                      @change="wizardFieldChange('debtors', data.item.index)"
                                    />
                                    <b-form-input
                                      v-else-if="variable.type === 'number'"
                                      :id="'debtor-'+variable.variable+'-'+data.item.index"
                                      v-model="data.item.fullData.variables[varIndex].value"
                                      type="number"
                                      :placeholder="$t(variable.variable)"
                                      :readonly="debtorsBelongToCompany"
                                      @change="wizardFieldChange('debtors', data.item.index), checkRequiredField(`debtor-${variable.variable}-${data.item.index}`, $event)"
                                    />
                                    <b-form-input
                                      v-else
                                      :id="'debtor-'+variable.variable+'-'+data.item.index"
                                      v-model="data.item.fullData.variables[varIndex].value"
                                      :placeholder="$t(variable.variable)"
                                      :readonly="debtorsBelongToCompany"
                                      @change="wizardFieldChange('debtors', data.item.index), checkRequiredField(`debtor-${variable.variable}-${data.item.index}`, $event)"
                                    />
                                    <small
                                      :id="'text-danger-'+variable.id"
                                      class="noShow"
                                    >Field {{ $t(variable.variable) }} is required.</small>
                                    <label
                                      :id="'debtor_custom_fields-dateerror-'+variable.variable"
                                      style="color: red; display:none;"
                                    >*{{ $t('DEBTIA_DATE_FORMAT_ERROR') }}</label>
                                  </b-form-group>
                                </div>
                              </b-col>
                            </b-row>
                          </b-card>
                        </b-col>
                      </b-row>
                    </b-card>
                  </template>
                </b-table>
              </b-row>
            </tab-content>
          </keep-alive>
        </form-wizard>
      </b-overlay>
    </b-modal>
  </div>
</template>

<script>
import { FormWizard, TabContent } from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import {
  BFormTextarea,
  BRow,
  BInputGroup,
  BCol,
  BOverlay,
  BSpinner,
  BFormGroup,
  BCard,
  BCardBody,
  BCardTitle,
  BCardText,
  BButton,
  BFormInput,
  BTable,
  BFormFile,
  BInputGroupPrepend,
  BFormCheckbox,
  BAlert,
  BInputGroupAppend,
  BFormDatepicker,
  BTableLite,
  VBTooltip,
  BFormRadioGroup,
} from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { heightTransition } from '@core/mixins/ui/transition'
import Ripple from 'vue-ripple-directive'
import axios from '@axios'
import constants from '@/app-configs/constants'
import vSelect from 'vue-select'
import VueTimepicker from 'vue2-timepicker'
import useAppConfig from '@core/app-config/useAppConfig'
import 'vue2-timepicker/dist/VueTimepicker.css'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import i18n from '@/libs/i18n'
import Cleave from 'vue-cleave-component'
import countries from '@/countries'
import TimeField from '@/layouts/components/TimeField.vue'
import Busy from './Busy.vue'
// eslint-disable-next-line import/no-extraneous-dependencies
import 'cleave.js/dist/addons/cleave-phone.us'

export default {
  components: {
    FormWizard,
    TabContent,
    BRow,
    BCol,
    BInputGroupPrepend,
    BOverlay,
    BSpinner,
    BFormGroup,
    BFormInput,
    BCard,
    BCardBody,
    BCardTitle,
    BCardText,
    BButton,
    BTable,
    BFormFile,
    BInputGroup,
    BFormCheckbox,
    BAlert,
    vSelect,
    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
    Busy,
    BInputGroupAppend,
    BFormDatepicker,
    BTableLite,
    Cleave,
    BFormTextarea,
    BFormRadioGroup,
    VueTimepicker,
    TimeField,
    // BCardCode,
  },
  directives: {
    'b-tooltip': VBTooltip,
    Ripple,
  },
  mixins: [heightTransition, togglePasswordVisibility],
  props: {
    reloadMethod: {
      type: Function,
      required: true,
    },
    modalLoads: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      countries,
      clientsLoader: false,
      termsheetCodeLoader: false,
      onHidden: false,
      cvrLengthMsg: '',
      incorrectCVR: false,
      loader: false,
      busytext: '',
      selectedDebtor: '',
      selectedClient: '',
      selectedTermsheetCode: '',
      selectedCaseGroup: '',
      nextButton: 'Next',
      maxfee: 300,
      noinputmsg: '',
      noinput: false,
      role: JSON.parse(localStorage.getItem('userData')).role[0],
      user_id: JSON.parse(localStorage.getItem('userData')).data.id,
      debt_case_id: 0,
      sentAtDate: '',
      dueDate: '',
      busy: false,
      processing: false,
      baseDocumentsIndex: 1,
      creditNotesIndex: 0,
      debtReminderIndex: 0,
      otherFileIndex: 0,
      debtorIndex: 1,
      stickyHeader: true,
      noCollapse: false,
      maxCompensationFee: 310,
      caseGroupsOptions: [],
      loginOptions: [
        { label: 'Allowed', value: 1 },
        { label: 'Not Allowed', value: 0 },
      ],
      clientsOptions: [],
      termSheetCodeOptions: [],
      debtorTypeOptions: [
        { label: 'Person', value: 'person' },
        { label: 'Sole Proprietorship', value: 'sole-proprietorship' },
        { label: 'Capital Company', value: 'capital-company' },
      ],
      tableFields: [
        { key: 'file', tdClass: 'fileclass' },
        { key: 'removeRecord' },
        { key: 'details' },
      ],
      items: [
        {
          index: 1,
          file: '[Add Document]',
          fullData: {
            recordIndex: 1,
            file: '',
            title: '',
            sentAt: '',
            daSentAt: '',
            dueDate: '',
            daDueDate: '',
            dueDateValid: false,
            paymentAmount: '',
            vatAmount: '',
            amountPaid: {
              status: false,
              value: '',
            },
            interestRate: {
              status: false,
              value: '',
            },
          },
          dataCompleted: false,
        },
      ],
      debtReminderitems: [],
      creditNoteitems: [],
      otherFilesitems: [],
      selectedTime: '',
      capitalCompanyActive: false,
      debtorsitems: [
        {
          index: 1,
          file: '[Add Debtor]',
          fullData: {
            recordIndex: 1,
            debtorID: 0,
            username: {
              required: true,
              value: '',
              unique: true,
            },
            password: {
              required: true,
              value: this.$getRandomPassword(),
            },
            loginStatus: {
              required: true,
              value: 1,
            },
            name: {
              required: true,
              value: '',
            },
            co: {
              required: false,
              value: '',
            },
            bank_branch_no: {
              required: false,
              value: '',
            },
            bank_account_no: {
              required: false,
              value: '',
            },
            cpn: {
              required: false,
              value: '',
            },
            debtortype: {
              required: true,
              value: '',
            },
            cpr: {
              required: false,
              value: '',
            },
            cvrnumber: {
              required: false,
              value: '',
            },
            hide_address: false,
            address: {
              road_name: {
                required: true,
                value: '',
              },
              house_number: {
                required: true,
                value: '',
              },
              place: {
                required: false,
                value: '',
              },
              zip_code: {
                required: true,
                value: '',
              },
              court_id: {
                required: false,
                value: 0,
              },
              city: {
                required: true,
                value: '',
              },
              country_id: {
                required: true,
                value: 247,
              },
            },
            phone: {
              required: false,
              value: '',
            },
            email: {
              required: false,
              value: '',
            },
            debtorGeneralDates: {},
          },
          dataCompleted: false,
        },
      ],
      clientDebtors: [],
      activeOption: 0,
      toGrabIndex: 0,
      clientId: '',
      termsheetCode: '',
      PasswordNotRequired: false,
      summaryClientName: '',
      summaryClientId: 0,
      summaryDocumentBaseType: '',
      summaryBaseDocuments: [],
      summaryCreditNotes: [],
      summaryDebtReminders: [],
      summaryOtherFiles: [],
      summaryDebtors: [],
      categoryOptions: [],
      customVariables: [],
      airportOptions: [],
      summaryTotalDebtAmount: 0,
      caseGroups: [],
      debtorsBelongToCompany: localStorage.getItem('debtorsBelongTo') === 'company',
      defaultCurrency: localStorage.getItem('defaultCurrency'),
      defaultCurrencySymbol: localStorage.getItem('defaultCurrency') === 'EUR' ? '€' : 'kr.',
      options: {
        cprDelimiter: {
          delimiters: ['-'],
          blocks: [6, 4],
          uppercase: true,
        },
        date: {
          date: true,
          delimiter: '-',
          datePattern: ['d', 'm', 'Y'],
        },
      },
      postCustomVariables: [],
      radioOptions: [
        { item: 'true', name: 'True' },
        { item: 'false', name: 'False' },
      ],
      // this will used to make the custom variable object reactive
      debtorReactiveVar: '',
      courts: [],
      caseGeneralDates: {},
      defaultTermsheetCode: '',
      caseMaxLimit: false,
    }
  },
  computed: {
    debtorPassword() {
      return {
        active: false,
        style: 'display: none;',
      }
    },
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
  },
  watch: {
    selectedClient: {
      handler() {
        this.clientId = this.selectedClient
        this.getDebtors(this.clientId)
        this.resetDebtors()
        this.resetTermsheetcode()
      },
    },
    selectedTermsheetCode: {
      handler() {
        this.termsheetCode = this.selectedTermsheetCode
      },
    },
    caseGroups: {
      handler() {
        this.insertCaseGroups()
      },
    },
    // selectedDebtor: {
    //   handler() {
    //     this.getDebtorDetails()
    //   },
    // },
  },
  setup() {
    const { skin } = useAppConfig()

    return {
      // Skin
      skin,
    }
  },
  created() {
    this.getCourtsDropdown()
    this.getGeneralDate('case', null)
    this.getGeneralDate('debtor', 0)
  },
  methods: {
    resetTermsheetcode() {
      const client = this.clientsOptions.find(element => element.value === this.selectedClient)
      this.selectedTermsheetCode = client.termsheetcode ? client.termsheetcode : this.defaultTermsheetCode
    },
    assignDateValue(value, obj, attribute) {
      const parts = value.split('-')
      const day = Number(parts[2])
      const month = Number(parts[1])
      const year = Number(parts[0])
      const formattedDate = `${day < 10 ? '0' : ''}${day}-${month < 10 ? '0' : ''}${month}-${year}`
      // eslint-disable-next-line no-param-reassign
      obj[attribute] = formattedDate
    },
    async getGeneralDate(type, index) {
      await axios.get(`${constants.serverBaseUrl}/api/v2/debtiaapp/${type}/get-custom-variables`)
        .then(response => {
          const result = response.data.data.variables
          result.forEach(element => {
            if (element.type === 'date') {
              if (type === 'case') {
                this.$set(this.caseGeneralDates, element.variable, null)
                this.$set(this.caseGeneralDates, `da${element.variable}`, null)
              }
              if (type === 'debtor') {
                this.$set(this.debtorsitems[index].fullData.debtorGeneralDates, element.variable, null)
                this.$set(this.debtorsitems[index].fullData.debtorGeneralDates, `da${element.variable}`, null)
              }
            }
          })
        }).catch(() => false)
    },
    checkRequiredDropdown(id) {
      const elementSelected = document.getElementById(id)
      const parentElement = elementSelected ? elementSelected.closest('.vs__dropdown-toggle') : ''
      const classNameToCheck = 'requiredError'
      if (this.hasClassInParents(elementSelected, classNameToCheck)) {
        parentElement.classList.remove('requiredError')
      }
    },
    checkRequiredField(id, value) {
      const element = document.getElementById(id)
      const className = 'requiredError'

      if (element.classList.contains(className) && value) {
        element.classList.remove(className)
      }
    },
    async getCourtsDropdown() {
      await axios.get('settings/courts/dropdown')
        .then(response => {
          this.courts = [{ label: 'Select Court', value: 0 }, ...response.data.data]
        }).catch(() => false)
    },
    async createUsername() {
      const url = `${constants.baseUrl}/create-validate/username`
      let username = ''
      await axios.post(url, {
        type: 'client',
      }).then(response => {
        if (response.status === 200) {
          username = response.data.data.username
        }
      })
      return username
    },
    timeFieldCheck(value, variable) {
      const { hour, minute } = this.$refs[`time-ref-${value}`][0]
      let timeValue = ''
      if (hour && minute) {
        timeValue = `${hour}:${minute}`
        this.customVariableChange(timeValue, variable, value)
      } else {
        timeValue = ''
        // this.customVariableChange(timeValue, variable, value)
      }
    },
    timeFieldColor() {
      const fields = document.getElementsByClassName('time-picker')
      Array.from(fields).forEach(field => {
        const dropdownChildren = field.children[1].classList.contains('dropdown') ? field.children[1] : field.children[2]
        // eslint-disable-next-line no-param-reassign
        dropdownChildren.firstChild.style.backgroundColor = this.skin === 'light' ? 'white' : '#3b4662'
        // eslint-disable-next-line no-param-reassign
        if (this.skin === 'light') {
          dropdownChildren.firstChild.children[0].classList.remove('timepick-hours')
          dropdownChildren.firstChild.children[1].classList.remove('timepick-minutes')
        } else {
          dropdownChildren.firstChild.children[0].classList.add('timepick-hours')
          dropdownChildren.firstChild.children[1].classList.add('timepick-minutes')
        }
      })
    },
    async getCaseGroups() {
      this.loader = true
      const url = '/debt-case-groups-dropdown'
      await axios.get(url).then(response => {
        if (response.status === 200) {
          this.caseGroups = response.data.data
          this.loader = false
        }
      })
    },
    async getDebtorCustomVariables() {
      await axios.get(`${constants.serverBaseUrl}/api/v2/debtiaapp/debtor/get-custom-variables`)
        .then(response => {
          const variables = []
          response.data.data.variables.forEach(element => {
            if (element.display_in_add_edit_page === 1) {
              variables.push(element)
            }
          })
          this.debtorCustomVariables = variables
          this.attachCustomVariables(0)
        }).catch(() => false)
    },
    attachCustomVariables(index) {
      const customVars = []
      this.debtorCustomVariables.forEach(element => {
        if (element.display_in_add_edit_page === 1) {
          const isRequired = element.is_required === 1
          const obj = {
            id: 0,
            value: '',
            var_name: element.variable,
            custom_variable_id: element.id,
            required: isRequired,
            type: element.type,
          }
          customVars.push(obj)
        }
      })
      this.debtorsitems[index].fullData.variables = customVars
    },
    customVariableChange(event, variable, id) {
      let exists = false
      // let value = event
      // if (event.mm) {
      //   value = `${event.HH}:${event.mm}:00`
      // }
      let timeVal = null
      if (typeof event === 'object') {
        const hours = event.HH.toString().padStart(2, '0')
        const minutes = event.mm.toString().padStart(2, '0')
        timeVal = `${hours}:${minutes}`
      }
      if (this.postCustomVariables.length > 0) {
        this.postCustomVariables.forEach((element, index) => {
          if (element.customVarLabel === variable) {
            this.postCustomVariables[index].value = timeVal !== null ? timeVal : event
            exists = true
          }
        })
      }
      if (this.postCustomVariables.length === 0 || !exists) {
        this.postCustomVariables.push({
          customVarLabel: variable,
          value: timeVal !== null ? timeVal : event,
        })
      }
      document.getElementById(`text-danger-${id}`).classList.remove('alert-general-variable')
      document.getElementById(`text-danger-${id}`).classList.add('noShow')
    },
    async getCustomVariables() {
      await axios.get(`${constants.serverBaseUrl}/api/v2/debtiaapp/case/get-custom-variables`)
        .then(response => {
          this.customVariables = response.data.data.variables
          this.airportOptions = response.data.data.options
        }).catch(() => false)
    },
    insertCaseGroups() {
      this.caseGroupsOptions = [{ label: 'Select Case Group...', value: '' }, ...this.caseGroups]
    },
    paymentValidity(step, index, value, type) {
      if (value && value < 1) {
        document.getElementById(`${step}-${type}-${index}`).style.display = 'block'
      } else {
        document.getElementById(`${step}-${type}-${index}`).style.display = 'none'
      }
      this.wizardFieldChange(step, index)
    },
    dueDateValidity(step, index, item) {
      this.getTableIndex(step, index)
      let record = {}
      let compareDate = ''
      if (step === 'debtreminders') {
        compareDate = item.documentDate
      } else {
        compareDate = item.sentAt
      }
      record = this.getMainObjectWithStepType(step)
      if (compareDate && item.dueDate) {
        record[this.toGrabIndex].fullData.dueDateValid = false
        if (compareDate > item.dueDate) {
          document.getElementById(`${step}-duedateerror-${index}`).style.display = 'block'
        }
        if (this.returnValidateDate(item.dueDate) && this.returnValidateDate(compareDate) && (compareDate < item.dueDate)) {
          record[this.toGrabIndex].fullData.dueDateValid = true
          document.getElementById(`${step}-duedateerror-${index}`).style.display = 'none'
        }
      }
      // this.wizardFieldChange(step, index)
    },
    assignValue(step, index, varIndex, value) {
      let record = {}
      this.getTableIndex(step, index)
      record = this.getMainObjectWithStepType(step)
      record[this.toGrabIndex].fullData.variables[varIndex].value = this.normalToDa(value)
    },
    returnValidateDate(validatingDate) {
      const regex = /^\d{4}-\d{2}-\d{2}$/
      if (regex.test(validatingDate)) {
        return true
      }
      return false
    },
    normalToDa(value) {
      const parts = value.split('-')
      const day = Number(parts[0])
      const month = Number(parts[1])
      const year = Number(parts[2])
      const formattedDate = `${year}-${month < 10 ? '0' : ''}${month}-${day < 10 ? '0' : ''}${day}`
      return formattedDate
    },
    validateDate(step, mapId, index, obj, value, daValue) {
      const regex = /^\d{2}-\d{2}-\d{4}$/
      if (step === 'general_custom_fields' || step === 'debtor_custom_fields') {
        if (!regex.test(obj[value])) {
          document.getElementById(`${step}-${mapId}-${index}`).style.display = 'block'
        } else {
          // eslint-disable-next-line no-param-reassign
          obj[daValue] = this.normalToDa(obj[value])
          document.getElementById(`${step}-${mapId}-${index}`).style.display = 'none'
        }
      } else {
        this.getTableIndex(step, index)
        if (!regex.test(obj[value])) {
          document.getElementById(`${step}-${mapId}-${index}`).style.display = 'block'
        } else {
          // eslint-disable-next-line no-param-reassign
          obj[daValue] = this.normalToDa(obj[value])
          document.getElementById(`${step}-${mapId}-${index}`).style.display = 'none'
        }
      }
    },
    async validateUserName(value, id) {
      if (value) {
        this.getTableIndex('debtors', id)
        let record = {}
        record = this.getMainObjectWithStepType('debtors')
        let debtorID = 0
        if (record[this.toGrabIndex].fullData.debtorID > 0) {
          debtorID = record[this.toGrabIndex].fullData.debtorID
        }
        const validation = await axios.post('debtor/validate-username', { exclude: [debtorID], username: value })
          .then(() => true).catch(() => false)

        if (!validation) {
          record[this.toGrabIndex].fullData.username.unique = false
          document.getElementById(`usernameerror-${id}`).style.display = 'block'
        } else {
          record[this.toGrabIndex].fullData.username.unique = true
          document.getElementById(`usernameerror-${id}`).style.display = 'none'
        }
        this.toGrabIndex = 0
        this.wizardFieldChange('debtors', id)
      }
    },
    getZipcode(event, index) {
      this.getTableIndex('debtors', index)
      let record = {}
      record = this.getMainObjectWithStepType('debtors')

      const countryId = this.debtorsitems[this.toGrabIndex]?.fullData?.address?.country_id?.value
      if (countryId !== 247) return
      axios.get(`settings/get-zip-code-by-city-name?city=${event}`)
        .then(response => {
          if (response.data.data.zip_code !== null) {
            document.getElementById(`debtor-zip_code-${index}`).value = response.data.data.zip_code
            record[this.toGrabIndex].fullData.address.zip_code.value = response.data.data.zip_code
            this.getCityNCourtName((response.data.data.zip_code.length !== '') ? response.data.data.zip_code : 0)
            this.wizardFieldChange('debtors', index)
            this.checkRequiredField(`debtor-zip_code-${index}`, event)
          }
        }).catch(error => {
          console.log(error)
        })
    },
    getCityNCourtName(event, index) {
      this.getTableIndex('debtors', index)
      let record = {}
      record = this.getMainObjectWithStepType('debtors')
      const countryId = this.debtorsitems[this.toGrabIndex]?.fullData?.address?.country_id?.value
      if (countryId !== 247) return
      axios.get(`settings/get-city-court-by-code?code=${event}&country_id=${countryId}`)
        .then(response => {
          if (response.data.data.city_name !== null) {
            document.getElementById(`debtor-city-${index}`).value = response.data.data.city_name
            record[this.toGrabIndex].fullData.address.city.value = response.data.data.city_name
            record[this.toGrabIndex].fullData.address.court_id.value = response.data.data.court_id
            this.wizardFieldChange('debtors', index)
            this.checkRequiredField(`debtor-city-${index}`, event)
          }
        }).catch(error => {
          console.log(error)
        })
    },
    debtorTypeChanged(event, index) {
      this.getTableIndex('debtors', index)
      let record = {}
      record = this.getMainObjectWithStepType('debtors')
      if (event === 'person') {
        this.incorrectCVR = false
        record[this.toGrabIndex].fullData.cvrnumber.value = ''
      } else {
        record[this.toGrabIndex].fullData.cpr.value = ''
      }
    },
    cvrChecker(value, id) {
      const element = document.getElementById(`debtor-cvr-error-${id}`)
      const countryId = this.debtorsitems[this.toGrabIndex].fullData.address.country_id.value
      if (!element) return

      if (countryId === 247) {
        if (value.length > 0 && value.length !== 8) {
          this.incorrectCVR = true
          element.innerText = this.$t('DEBTIA_CVR_LENGTH_MSG')
          element.classList.remove('cvr-error-hide')
          element.classList.add('cvr-error-show')
        } else {
          this.incorrectCVR = false
          element.classList.remove('cvr-error-show')
          element.classList.add('cvr-error-hide')
        }
      } else {
        this.incorrectCVR = false
        element.classList.remove('cvr-error-show')
        element.classList.add('cvr-error-hide')
      }
    },
    getClients() {
      this.clientsLoader = true
      const url = '/clients/dropdown'
      axios.get(url).then(response => {
        if (response.status === 200) {
          const clients = response.data.data
          this.clientsOptions = clients
          this.clientsLoader = false
        }
      })
    },
    async getTermsheetCodes() {
      this.termsheetCodeLoader = true
      const url = '/settings/termsheetcode-dropdown'
      await axios.get(url).then(response => {
        if (response.status === 200) {
          const termsheetCodes = response.data.data
          this.termSheetCodeOptions = termsheetCodes
          this.termsheetCodeLoader = false
        }
      })
    },
    async getSettingValues(selected) {
      this.loader = true
      await axios.get('user-settings/get', { params: { key: selected } }).then(response => {
        const settingDetails = response.data.data
        if (settingDetails === null) {
          this.defaultTermsheetCode = ''
          this.selectedTermsheetCode = ''
        } else {
          this.defaultTermsheetCode = settingDetails.value
          this.selectedTermsheetCode = settingDetails.value
        }
        this.loader = false
      }).catch(() => {
        this.getDefaultValues(selected)
        this.loader = false
      })
    },
    getDebtorDetails(index, debtorID) {
      this.busy = true
      this.processing = true
      this.busytext = 'Fetching debtors details.'
      const url = `/debtor/view?id=${debtorID}`
      axios.get(url).then(response => {
        if (response.status === 200) {
          const entry = this.debtorsitems.filter(record => response.data.data.id === record.fullData.debtorID)
          if (entry.length > 1) {
            this.noinput = true
            if (entry.length > 1) this.noinputmsg = i18n.t('DEBTIA_DEBTOR_ALREADY_SELECTED')
            if (!response.data.data.debtor_address) this.noinputmsg = i18n.t('DEBTIA_INVALID_DEBTOR')
            this.getTableIndex('debtors', index)
            let record = {}
            record = this.getMainObjectWithStepType('debtors')
            record[this.toGrabIndex].fullData.debtorID = 0
            // data.birthdate.value = response.data.data.birthdate
            const data = this.debtorsitems[this.toGrabIndex].fullData
            data.debtorID = 0
            data.username.value = ''
            data.username.unique = false
            // data.password.required = 0
            // this.PasswordNotRequired = false
            data.name.value = ''
            data.co.value = ''
            data.cpn.value = ''
            data.debtortype.value = ''
            data.cvrnumber.value = ''
            data.loginStatus.value = 1
            data.cpr.value = ''
            data.hide_address = false
            data.address.road_name.value = ''
            data.address.house_number.value = ''
            data.address.place.value = ''
            data.address.zip_code.value = ''
            data.address.city.value = ''
            data.address.court_id.value = 0
            data.address.country_id.value = 247
            data.phone.value = ''
            data.email.value = ''
            data.bank_account_no.value = ''
            data.bank_branch_no.value = ''
            data.loginStatus.value = 1
            data.variables.forEach((element, elindex) => {
              data.variables[elindex].value = ''
              data.variables[elindex].custom_variable_id = ''
            })
            this.wizardFieldChange('debtors', index)
            this.busy = false
            setTimeout(() => {
              this.noinput = false
              this.noinputmsg = ''
            }, 5000)
            this.toGrabIndex = 0
          } else {
            setTimeout(() => {
              this.getTableIndex('debtors', index)
              const data = this.debtorsitems[this.toGrabIndex].fullData
              data.debtorID = response.data.data.id
              data.username.value = response.data.data.username
              this.checkRequiredField(`debtor-username-${index}`, data.username.value)
              data.username.unique = true
              data.password.required = 0
              this.PasswordNotRequired = true
              data.name.value = response.data.data.name
              this.checkRequiredField(`debtor-name-${index}`, data.name.value)
              data.co.value = response.data.data.care_of
              data.cpn.value = response.data.data.contact_person
              data.debtortype.value = response.data.data.debtor_type
              this.checkRequiredDropdown(`debtor-debtortype-${index}`)
              data.cvrnumber.value = response.data.data.cvr_number
              data.loginStatus.value = response.data.data.loginStatus
              this.checkRequiredDropdown(`debtor-loginStatus-${index}`)
              data.cpr.value = response.data.data.cpr
              data.hide_address = response.data.data.hide_address
              data.address.road_name.value = response.data.data.debtor_address?.road_name ? response.data.data.debtor_address.road_name : ''
              this.checkRequiredField(`debtor-road_name-${index}`, data.address.road_name.value)
              data.address.house_number.value = response.data.data.debtor_address?.house_no ? response.data.data.debtor_address.house_no : ''
              this.checkRequiredField(`debtor-house_number-${index}`, data.address.house_number.value)
              data.address.place.value = response.data.data.debtor_address?.place ? response.data.data.debtor_address.place : ''
              data.address.zip_code.value = response.data.data.debtor_address?.zip_code ? response.data.data.debtor_address.zip_code : ''
              this.checkRequiredField(`debtor-zip_code-${index}`, data.address.zip_code.value)
              data.address.city.value = response.data.data.debtor_address?.city ? response.data.data.debtor_address.city : ''
              this.checkRequiredField(`debtor-city-${index}`, data.address.city.value)
              data.address.court_id.value = response.data.data.debtor_address?.court_id ? response.data.data.debtor_address.court_id : 0
              data.address.country_id.value = response.data.data.debtor_address?.country_id ? response.data.data.debtor_address.country_id : 247
              this.checkRequiredDropdown(`debtor-country-${index}`)
              data.phone.value = response.data.data.phone
              data.email.value = response.data.data.email
              data.bank_account_no.value = response.data.data.bank_account_no
              data.bank_branch_no.value = response.data.data.bank_branch_no
              data.loginStatus.value = Number(response.data.data.loginStatus)
              data.variables.forEach((element, elindex) => {
                if (response.data.data.custom_variables_v2[0].id === 0) {
                  data.variables[elindex].value = ''
                } else {
                  const res = response.data.data.custom_variables_v2[elindex]
                  data.variables[elindex].value = res.customVarValue
                  data.variables[elindex].id = res.id
                }
                if (element.required && response.data.data.custom_variables_v2[elindex].type === 'select') {
                  this.checkRequiredDropdown(`debtor-${element.var_name}-${index}`)
                }
                if (element.required && response.data.data.custom_variables_v2[elindex].type !== 'select') {
                  this.checkRequiredField(`debtor-${element.var_name}-${index}`, data.variables[elindex].value)
                }
              })
              // data.birthdate.value = response.data.data.birthdate
              this.wizardFieldChange('debtors', index)
              this.busy = false
            }, 2000)
          }
        }
        this.toGrabIndex = 0
      }).catch(error => {
        this.noinput = true
        this.noinputmsg = error.response.data.message ? error.response.data.message : error.message
      })
    },
    async getCategoryOptions() {
      const url = '/settings/file-categories-dropdown'
      await axios.get(url).then(response => {
        if (response.status === 200) {
          this.categoryOptions = [{ label: 'Select Category', value: 0 }, ...response.data.data]
        }
      })
    },
    getDebtors(id) {
      const url = `/debtor/dropdown?client_id=${id}`
      axios.get(url).then(response => {
        if (response.status === 200) {
          const debtors = response.data.data
          this.clientDebtors = debtors
        }
      })
    },
    handleTabChange(prevIndex, nextIndex) {
      this.nextButton = 'Next'
      if ((nextIndex === 2 && Object.keys(this.creditNoteitems).length === 0)
      || (nextIndex === 3 && Object.keys(this.debtReminderitems).length === 0)
      || (nextIndex === 4 && Object.keys(this.otherFilesitems).length === 0)) {
        this.nextButton = 'Skip'
      }
    },
    wizardFieldChange(step, index) {
      this.getTableIndex(step, index)
      let record = {}
      record = this.getMainObjectWithStepType(step)
      let emptyvalue = 0
      if (step === 'debtors') {
        const keys = Object.keys(record[this.toGrabIndex].fullData)
        for (const key of keys) {
          const currentVal = record[this.toGrabIndex].fullData[key]
          if (key === 'username' && !currentVal.unique) {
            emptyvalue += 1
          } else if (key !== 'address' && key !== 'cvrnumber' && key !== 'variables') {
            if (((currentVal.value === null || currentVal.value === '') && currentVal.required === true)) {
              emptyvalue += 1
            }
          } else if (key === 'variables') {
            // eslint-disable-next-line no-loop-func
            currentVal.forEach(element => {
              const funcResult = this.returnValidateDate(element.value)
              if (element.type === 'date' && !funcResult) {
                emptyvalue += 1
              }
            })
          } else {
            const internaladdress = Object.keys(currentVal)
            for (const address of internaladdress) {
              const addressField = record[this.toGrabIndex].fullData[key][address]

              // If field is missing entirely
              if (addressField === null || addressField === undefined) {
                emptyvalue += 1
                this.busy = false
              } else {
                // Field exists — check required + value
                const req = addressField.required
                const internalval = addressField.value
                if ((internalval === null || internalval === '') && req === true) {
                  emptyvalue += 1
                }
              }
            }
          }
        }
      } else if ((step === 'basedocuments' || step === 'debtreminders') && !record[this.toGrabIndex].fullData.dueDateValid) {
        emptyvalue += 1
      } else if ((step === 'basedocuments') && (record[this.toGrabIndex].fullData.paymentAmount < 1)) {
        emptyvalue += 1
      } else if ((step === 'creditnotes') && ((record[this.toGrabIndex].fullData.creditNoteAmount < 1) || !this.returnValidateDate(record[this.toGrabIndex].fullData.sentAt))) {
        emptyvalue += 1
      } else if ((step === 'debtreminders') && (record[this.toGrabIndex].fullData.reminderFee < 0 || record[this.toGrabIndex].fullData.compensationFee < 0)) {
        emptyvalue += 1
      } else {
        const keys = Object.values(record[this.toGrabIndex].fullData)
        for (const key of keys) {
          if ((key === null || key === '') && step !== 'basedocuments') {
            emptyvalue += 1
          }
          if (typeof key === 'object') {
            if (key.status === true && (key.value === null || key.value === '')) {
              emptyvalue += 1
            }
          }
        }
      }
      const btnId = `${step}-btn-${index}`
      const rowId = document.getElementById(btnId).parentNode.parentNode.parentNode.id
      this.getTableIndex(step, index)
      if (step === 'debtors' && record[this.toGrabIndex].fullData.name.value !== '') {
        document.querySelector(`#${rowId} td.fileclass`).innerHTML = `<span>${record[this.toGrabIndex].fullData.name.value}</span>`
      }
      if (emptyvalue === 0) {
        this.getTableIndex(step, index)
        record[this.toGrabIndex].dataCompleted = true
        this.toGrabIndex = 0
        document.querySelector(`#${rowId}`).style = 'background-color: #c0f3d0  !important'
      } else {
        record[this.toGrabIndex].dataCompleted = false
        document.querySelector(`#${rowId}`).style = 'background-color: #f9f9f9 !important'
      }
      this.toGrabIndex = 0
    },
    openDetails(step, row) {
      if (!row.detailsShowing && row.item.fullData.file) {
        setTimeout(() => {
          document.querySelector(`#${step}-file-span-${row.item.index}`).innerHTML = row.item.fullData.file.name
        }, 50)
      }
      setTimeout(() => {
        if (step === 'basedocuments') {
          const paidamnt = document.getElementById(`paidamountref-${row.item.index}`).value
          const interest = document.getElementById(`interestfieldref-${row.item.index}`).value
          if (paidamnt > 0) {
            document.getElementById(`paidamountref-${row.item.index}`).removeAttribute('readonly')
            document.getElementById(`amountPaidCheckboxMask-${row.item.index}`).classList.add('checkboxActive')
          }
          if (interest > 0) {
            document.getElementById(`interestfieldref-${row.item.index}`).removeAttribute('readonly')
            document.getElementById(`interestRateCheckboxMask-${row.item.index}`).classList.add('checkboxActive')
          }
        }
        if (step === 'debtors' && (!row.detailsShowing && this.noinputmsg)) this.highlightDebtorsRequiredFields(row.item)
      }, 50)
      row.toggleDetails()
    },
    checkboxActivationFunction(index, type, mask, id) {
      if (document.getElementById(type).checked) {
        document.getElementById(index).removeAttribute('readonly')
        document.getElementById(mask).classList.add('checkboxActive')
      } else {
        const record = this.items.filter(element => element.index === id)
        if (type.indexOf('amountPaidCheckbox') >= 0) {
          record[0].fullData.amountPaid.value = ''
        } else {
          record[0].fullData.interestRate.value = ''
        }
        document.getElementById(index).value = ''
        document.getElementById(index).setAttribute('readonly', true)
        document.getElementById(mask).classList.remove('checkboxActive')
      }
      this.wizardFieldChange('basedocuments', id)
    },
    validateFile(step, event, index) {
      const file = event.target.files[0]
      if (file) {
        this.busy = true
        this.processing = true
        this.busytext = i18n.t('DEBTIA_SYSTEM_VALIDATING_MSG')
        const id = event.target.id.split('-')[2]
        const btnId = `${step}-btn-${id}`
        const rowId = document.getElementById(btnId).parentNode.parentNode.parentNode.id
        const filetype = file ? file.type : ''
        const filename = file ? file.name : ''
        this.getTableIndex(step, index)
        const mainObject = this.getMainObjectWithStepType(step)
        setTimeout(() => {
          let responseIcon = ''
          if (file
            && ((((filename && filename.includes('.docx'))
              || (filename && filename.includes('.doc'))))
              || (filetype && filetype.includes('pdf')))) {
            responseIcon = '<svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-check-circle"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path><polyline points="22 4 12 14.01 9 11.01"></polyline></svg>'
            document.querySelector(`#${rowId}`).style = 'background-color: #f9f9f9 !important'
            this.getTableIndex(step, id)
            mainObject[this.toGrabIndex].fullData.file = file
            document.querySelector(`#${step}-file-span-${id}`).innerHTML = file.name
            this.toGrabIndex = 0
            this.wizardFieldChange(step, id)
          } else {
            mainObject[this.toGrabIndex].fullData.file = ''
            this.toGrabIndex = 0
            this.wizardFieldChange(step, id)
            responseIcon = '<svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-alert-circle"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line></svg>'
            document.querySelector(`#${rowId}`).style = 'background-color: rgb(255 192 192) !important'
            document.querySelector(`#${step}-file-span-${id}`).innerHTML = file.name
          }
          const featherIcon = `<div class="icon-wrapper response-icon">${responseIcon}</div>`
          document.querySelector(`#${rowId} td.fileclass`).innerHTML = `${featherIcon} <span>${filename}</span>`
          this.busy = false
        }, 2000)
      }
    },
    addDebtor() {
      this.loader = true
      this.PasswordNotRequired = false
      this.debtorIndex += 1
      this.createUsername().then(result => {
        const obj = {
          index: this.debtorIndex,
          file: '[Add Debtor]',
          fullData: {
            recordIndex: 1,
            debtorID: 0,
            username: {
              required: true,
              value: result,
              unique: true,
            },
            password: {
              required: true,
              value: this.$getRandomPassword(),
            },
            loginStatus: {
              required: true,
              value: 1,
            },
            name: {
              required: true,
              value: '',
            },
            co: {
              required: false,
              value: '',
            },
            bank_branch_no: {
              required: false,
              value: '',
            },
            bank_account_no: {
              required: false,
              value: '',
            },
            cpn: {
              required: false,
              value: '',
            },
            debtortype: {
              required: true,
              value: '',
            },
            cpr: {
              required: false,
              value: '',
            },
            cvrnumber: {
              required: false,
              value: '',
            },
            court_id: {
              required: false,
              value: 0,
            },
            hide_address: false,
            address: {
              road_name: {
                required: true,
                value: '',
              },
              house_number: {
                required: true,
                value: '',
              },
              place: {
                required: false,
                value: '',
              },
              zip_code: {
                required: true,
                value: '',
              },
              court_id: {
                required: false,
                value: 0,
              },
              city: {
                required: true,
                value: '',
              },
              country_id: {
                required: true,
                value: 247,
              },
            },
            phone: {
              required: false,
              value: '',
            },
            email: {
              required: false,
              value: '',
            },
            debtorGeneralDates: {},
          },
          dataCompleted: false,
        }
        const len = this.debtorsitems.push(obj)
        this.attachCustomVariables(len - 1)
        this.getGeneralDate('debtor', this.debtorIndex)
        this.loader = false
      })
    },
    addDebtReminders() {
      this.debtReminderIndex += 1
      const obj = {
        index: this.debtReminderIndex,
        file: '[Add Document]',
        fullData: {
          recordIndex: this.debtReminderIndex,
          file: '',
          documentDate: '',
          daDocumentDate: '',
          dueDate: '',
          daDueDate: '',
          dueDateValid: false,
          reminderFee: 0,
          compensationFee: 0,
        },
        dataCompleted: false,
      }
      this.nextButton = 'Next'
      this.debtReminderitems.push(obj)
    },
    addCreditNotes() {
      this.creditNotesIndex += 1
      const obj = {
        index: this.creditNotesIndex,
        file: '[Add Notes]',
        fullData: {
          recordIndex: this.creditNotesIndex,
          file: '',
          sentAt: '',
          daSentAt: '',
          creditNoteAmount: '',
        },
        dataCompleted: false,
      }
      this.nextButton = 'Next'
      this.creditNoteitems.push(obj)
    },
    addBaseDocument() {
      this.maxCompensationFee += 310
      this.baseDocumentsIndex += 1
      const obj = {
        index: this.baseDocumentsIndex,
        file: '[Add Document]',
        fullData: {
          recordIndex: this.baseDocumentsIndex,
          file: '',
          title: '',
          sentAt: '',
          daSentAt: '',
          dueDate: '',
          daDueDate: '',
          dueDateValid: false,
          paymentAmount: '',
          vatAmount: '',
          amountPaid: {
            status: false,
            value: '',
          },
          interestRate: {
            status: false,
            value: '',
          },
        },
        dataCompleted: false,
      }
      this.items.push(obj)
    },
    addOtherFiles() {
      this.otherFileIndex += 1
      const obj = {
        index: this.otherFileIndex,
        file: '[Add Document]',
        fullData: {
          recordIndex: this.otherFileIndex,
          file: '',
          title: '',
          category_id: 0,
        },
        dataCompleted: false,
      }
      this.nextButton = 'Next'
      this.otherFilesitems.push(obj)
    },
    selectOption(id) {
      this.activeOption = id
      if (this.debtReminderitems.length > 0) {
        // eslint-disable-next-line no-param-reassign
        this.debtReminderitems.forEach(element => { element.fullData.compensationFee = 0 })
      }
    },
    removeItem(step, index) {
      this.getTableIndex(step, index)
      const obj = this.getMainObjectWithStepType(step)
      if (step === 'basedocuments') {
        this.maxCompensationFee -= 310
      }
      if (((step === 'creditnotes' || step === 'debtreminders' || step === 'otherfiles') && this.toGrabIndex >= 0)
        || (((step === 'basedocuments' || step === 'debtors') && this.toGrabIndex > 0))) {
        obj.splice(this.toGrabIndex, 1)
      }
      if ((step === 'creditnotes' || step === 'debtreminders' || step === 'otherfiles') && Object.keys(obj).length === 0) {
        this.nextButton = 'Skip'
      }
      const btnId = `${step}-btn-${index}`
      const rowId = document.getElementById(btnId).parentNode.parentNode.parentNode.id
      const idbreak = rowId.split('row_')
      const partialID = `${idbreak[0]}`
      setTimeout(() => {
        obj.forEach(value => {
          if (step === 'debtors') {
            if (value.fullData.name.value && value.fullData.name.value !== '') {
              document.querySelector(`#${partialID}row_${value.index} td.fileclass`).innerHTML = value.fullData.name.value
            }
          } else {
            const fileNa = value.fullData.file
            if (fileNa) {
              const filename = fileNa.name
              let responseIcon = ''
              if (filename
                && ((filename.includes('.docx') || filename.includes('.doc'))
                || filename.includes('.pdf'))) {
                responseIcon = '<svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-check-circle"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path><polyline points="22 4 12 14.01 9 11.01"></polyline></svg>'
              } else {
                responseIcon = '<svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-alert-circle"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line></svg>'
              }
              document.querySelector(`#${partialID}row_${value.index} td.fileclass`).innerHTML = `${responseIcon} <span class="margin-left-span">${filename}</span>`
            }
          }
        })
      }, 100)
      this.toGrabIndex = 0
    },
    getTableIndex(step, recordIndex) {
      const obj = this.getMainObjectWithStepType(step)
      obj.forEach((value, i) => {
        if (value.index === Number(recordIndex)) {
          this.toGrabIndex = i
        }
      })
    },
    getMainObjectWithStepType(step) {
      let obj = {}
      if (step === 'basedocuments') { obj = this.items }
      if (step === 'creditnotes') { obj = this.creditNoteitems }
      if (step === 'debtreminders') { obj = this.debtReminderitems }
      if (step === 'otherfiles') { obj = this.otherFilesitems }
      if (step === 'debtors') { obj = this.debtorsitems }
      return obj
    },
    async generalstep() {
      let endresult = false
      let isValidated = true
      this.customVariables.forEach(element => {
        const elementExists = this.postCustomVariables.filter(ele => ele.customVarLabel === element.variable)
        if (element.display_in_add_edit_page === 1 && (elementExists.length < 1 || (elementExists.length > 0 && elementExists[0].value === ''))) {
          if (element.is_required) {
            isValidated = false
            document.getElementById(`text-danger-${element.id}`).classList.add('alert-general-variable')
            document.getElementById(`text-danger-${element.id}`).classList.remove('noShow')
          }
        }
        if (element.type === 'date' && (elementExists.length > 0 && (elementExists[0].value !== '' && !this.returnValidateDate(elementExists[0].value)))) {
          isValidated = false
        }
      })
      if (isValidated) {
        if (this.postCustomVariables.length > 0) {
          const url = `${constants.serverBaseUrl}/api/v2/debtiaapp/case/save-custom-variables`
          this.noinput = false
          await axios.post(url, {
            debt_case_id: this.debt_case_id,
            variables: this.postCustomVariables,
            action: 'add',
          }).then(response => {
            if (response.status === 200) {
              console.log(response)
            }
            endresult = true
          }).catch(error => {
            this.noinput = true
            this.noinputmsg = error.response.data.message ? error.response.data.message : error.message
            endresult = false
          })
        } else {
          endresult = true
        }
      }
      return endresult
    },
    async stepone() {
      let endresult = false
      const url = `${constants.baseUrl}/save-base-type`
      if (this.activeOption > 0 && this.selectedClient > 0 && (this.selectedTermsheetCode != null || this.selectedTermsheetCode !== '')) {
        this.noinput = false
        await axios.post(url, {
          base_type: this.activeOption,
          creditor_id: this.selectedClient,
          added_by: this.user_id,
          debt_case_group_id: this.selectedCaseGroup,
          user_type: 'employee',
        }).then(response => {
          if (response.status === 200) {
            this.debt_case_id = response.data.data.id
          }
          endresult = true
        }).catch(error => {
          this.noinput = true
          this.noinputmsg = error.response.data.message ? error.response.data.message : error.message
          endresult = false
        })
      } else {
        this.noinput = true
        this.noinputmsg = i18n.t('DEBTIA_SELECT_CLIENT_BASETYPE')
        endresult = false
      }
      return endresult
    },
    async steptwo() {
      let endresult = false
      let incompleteDate = 0
      this.items.forEach(element => {
        if (!element.dataCompleted) {
          incompleteDate += 1
        }
      })
      if (incompleteDate === 0) {
        this.noinput = false
        const arr = []
        const files = []
        const fileIds = []
        this.items.forEach(element => {
          arr.push(element.fullData)
          files.push(element.fullData.file)
          fileIds.push(element.index)
        })
        const url = `${constants.baseUrl}/save-base-documents`
        const form = new FormData()
        form.append('debt_case_id', this.debt_case_id)
        form.append('data', JSON.stringify(arr))
        fileIds.forEach((index, element) => {
          form.append(`basedocument_${index}`, files[element])
        })
        await axios.post(url, form, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }).then(response => {
          if (response.status === 200) {
            // console.log(response)
          }
          endresult = true
        }).catch(error => {
          this.noinput = true
          this.noinputmsg = error.response.data.message ? error.response.data.message : error.message
          endresult = false
        })
      } else {
        this.noinput = true
        this.noinputmsg = i18n.t('DEBTIA_FILL_FORM_MSG_AND_VALID_FILE')
        endresult = false
      }
      return endresult
    },
    async stepthree() {
      let endresult = false
      const url = `${constants.baseUrl}/save-credit-notes`
      const form = new FormData()
      if (this.nextButton === 'Skip') {
        form.append('debt_case_id', this.debt_case_id)
        form.append('data', [])
        await axios.post(url, form).then(response => {
          if (response.status === 200) {
            this.noinput = false
            endresult = true
          }
          endresult = true
        }).catch(error => {
          this.noinput = true
          this.noinputmsg = error.response.data.message ? error.response.data.message : error.message
          endresult = false
        })
      } else {
        let incompleteDate = 0
        this.creditNoteitems.forEach(element => {
          if (!element.dataCompleted) {
            incompleteDate += 1
          }
        })
        if (Object.keys(this.creditNoteitems).length > 0 && incompleteDate === 0) {
          this.noinput = false
          const arr = []
          const files = []
          const fileIds = []
          this.creditNoteitems.forEach(element => {
            arr.push(element.fullData)
            files.push(element.fullData.file)
            fileIds.push(element.index)
          })
          form.append('debt_case_id', this.debt_case_id)
          form.append('data', JSON.stringify(arr))
          fileIds.forEach((index, element) => {
            form.append(`creditnotes_${index}`, files[element])
          })
          await axios.post(url, form, {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          }).then(response => {
            if (response.status === 200) {
              // console.log(response)
            }
            endresult = true
          }).catch(error => {
            this.noinput = true
            this.noinputmsg = error.response.data.message ? error.response.data.message : error.message
            endresult = false
          })
        } else {
          this.noinput = true
          this.noinputmsg = i18n.t('DEBTIA_FILL_FORM_MSG_AND_VALID_FILE')
          endresult = false
        }
      }
      return endresult
    },
    async stepfour() {
      let endresult = false
      let totalReminderFee = 0
      let totalCompensationFee = 0
      const url = `${constants.baseUrl}/send-debt-reminders`
      const form = new FormData()
      if (this.nextButton === 'Skip') {
        form.append('debt_case_id', this.debt_case_id)
        form.append('base_type', this.activeOption)
        form.append('data', [])
        await axios.post(url, form).then(response => {
          if (response.status === 200) {
            this.noinput = false
            endresult = true
          }
          endresult = true
        }).catch(error => {
          this.noinput = true
          this.noinputmsg = error.response.data.message ? error.response.data.message : error.message
          endresult = false
        })
      } else {
        this.debtReminderitems.forEach(element => {
          const convertedReminderFee = Number(element.fullData.reminderFee)
          const convertedCompensationFee = Number(element.fullData.compensationFee)
          totalReminderFee += convertedReminderFee
          totalCompensationFee += convertedCompensationFee
        })
        if (totalReminderFee > this.maxfee && totalCompensationFee <= this.maxCompensationFee) {
          this.noinput = true
          this.noinputmsg = i18n.t('DEBTIA_COMBINED_AMOUNT_ERROR_ONE')
          endresult = false
        } else if (totalReminderFee <= this.maxfee && totalCompensationFee > this.maxCompensationFee) {
          this.noinput = true
          this.noinputmsg = `${i18n.t('DEBTIA_COMBINED_AMOUNT_ERROR_TWO')} ${this.maxCompensationFee} ${this.defaultCurrencySymbol}`
          endresult = false
        } else if (totalReminderFee > this.maxfee && totalCompensationFee > this.maxCompensationFee) {
          this.noinput = true
          this.noinputmsg = `${i18n.t('DEBTIA_COMBINED_AMOUNT_ERROR_THREE')} ${this.maxCompensationFee} ${this.defaultCurrencySymbol} ${i18n.t('DEBTIA_RESPECTIVELY')}.`
          endresult = false
        } else {
          endresult = true
        }
        if (endresult) {
          let incompleteDate = 0
          this.debtReminderitems.forEach(element => {
            if (!element.dataCompleted) {
              incompleteDate += 1
            }
          })
          if (Object.keys(this.debtReminderitems).length > 0 && incompleteDate === 0) {
            this.noinput = false
            const arr = []
            const files = []
            const fileIds = []
            this.debtReminderitems.forEach(element => {
              arr.push(element.fullData)
              files.push(element.fullData.file)
              fileIds.push(element.index)
            })
            form.append('debt_case_id', this.debt_case_id)
            form.append('base_type', this.activeOption)
            form.append('data', JSON.stringify(arr))
            fileIds.forEach((index, element) => {
              form.append(`debtreminders_${index}`, files[element])
            })
            await axios.post(url, form, {
              headers: {
                'Content-Type': 'multipart/form-data',
              },
            }).then(response => {
              if (response.status === 200) {
                // console.log(response)
              }
              endresult = true
            }).catch(error => {
              this.noinput = true
              this.noinputmsg = error.response.data.message ? error.response.data.message : error.message
              endresult = false
            })
            this.noinput = false
          } else {
            this.noinput = true
            this.noinputmsg = i18n.t('DEBTIA_FILL_FORM_MSG_AND_VALID_FILE')
            endresult = false
          }
        }
      }
      return endresult
    },
    async stepfive() {
      let endresult = false
      const url = `${constants.baseUrl}/upload-other-files`
      const form = new FormData()
      if (this.nextButton === 'Skip') {
        form.append('debt_case_id', this.debt_case_id)
        form.append('skip', true)
        form.append('data', [])
        await axios.post(url, form).then(response => {
          if (response.status === 200) {
            this.noinput = false
            endresult = true
            this.getDebtorCustomVariables()
            this.timeFieldColor()
          }
          endresult = true
        }).catch(error => {
          this.noinput = true
          this.noinputmsg = error.response.data.message ? error.response.data.message : error.message
          endresult = false
        })
      } else {
        let incompleteDate = 0
        this.otherFilesitems.forEach(element => {
          if (!element.dataCompleted) {
            incompleteDate += 1
          }
        })
        if (Object.keys(this.otherFilesitems).length > 0 && incompleteDate === 0) {
          this.noinput = false
          const arr = []
          const files = []
          const fileIds = []
          this.otherFilesitems.forEach(element => {
            arr.push(element.fullData)
            files.push(element.fullData.file)
            fileIds.push(element.index)
          })
          form.append('debt_case_id', this.debt_case_id)
          form.append('skip', true)
          form.append('data', JSON.stringify(arr))
          fileIds.forEach((index, element) => {
            form.append(`otherfiles_${index}`, files[element])
          })
          await axios.post(url, form, {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          }).then(response => {
            if (response.status === 200) {
              // console.log(response)
              this.getDebtorCustomVariables()
              this.timeFieldColor()
            }
            endresult = true
          }).catch(error => {
            this.noinput = true
            this.noinputmsg = error.response.data.message ? error.response.data.message : error.message
            endresult = false
          })
        } else {
          this.noinput = true
          this.noinputmsg = i18n.t('DEBTIA_FILL_FORM_MSG_AND_VALID_FILE')
          endresult = false
        }
      }
      return endresult
    },
    hasClassInParents(element, className) {
      let currentElement = element
      while (currentElement !== null) {
        if (currentElement.classList.contains(className)) {
          return true
        }
        currentElement = currentElement.parentElement
      }
      return false
    },
    highlightDebtorsRequiredFields(element) {
      Object.keys(element.fullData).forEach(key => {
        if (element.fullData[key].required !== undefined) {
          const id = `debtor-${key}-${element.index}`
          const elementSelected = document.getElementById(id)
          const parentElement = elementSelected ? elementSelected.closest('.vs__dropdown-toggle') : ''
          const classNameToCheck = 'vs__dropdown-toggle'
          if (element.fullData[key].required && (element.fullData[key].value === '' || element.fullData[key].value === null)) {
            if (this.hasClassInParents(elementSelected, classNameToCheck)) {
              parentElement.classList.add('requiredError')
            } else {
              elementSelected.classList.add('requiredError')
            }
          }
        } else {
          if (key === 'address') {
            Object.keys(element.fullData.address).forEach(addresskey => {
              const keyToCheck = addresskey === 'country_id' ? 'country' : addresskey
              const id = `debtor-${keyToCheck}-${element.index}`
              const elementSelected = document.getElementById(id)
              const parentElement = elementSelected ? elementSelected.closest('.vs__dropdown-toggle') : ''
              const classNameToCheck = 'vs__dropdown-toggle'
              if (element.fullData.address[addresskey].required && (element.fullData.address[addresskey].value === '' || element.fullData.address[addresskey].value === null)) {
                if (this.hasClassInParents(elementSelected, classNameToCheck)) {
                  parentElement.classList.add('requiredError')
                } else {
                  elementSelected.classList.add('requiredError')
                }
              }
            })
          }
          if (key === 'variables') {
            element.fullData.variables.forEach(variableelement => {
              if (variableelement.display_in_add_edit_page === 1 || variableelement.display_in_add_edit_page === true) {
                const id = `debtor-${variableelement.var_name}-${element.index}`
                const elementSelected = document.getElementById(id)
                const parentElement = elementSelected ? elementSelected.closest('.vs__dropdown-toggle') : ''
                const classNameToCheck = 'vs__dropdown-toggle'
                if (variableelement.required && (variableelement.value === '' || variableelement.value === null)) {
                  if (this.hasClassInParents(elementSelected, classNameToCheck)) {
                    parentElement.classList.add('requiredError')
                  } else {
                    elementSelected.classList.add('requiredError')
                  }
                }
              }
            })
          }
        }
      })
    },
    runStepSix() {
      this.loader = true
      setTimeout(() => {
        this.stepsix()
      }, 1500)
      return false
    },
    async stepsix() {
      let endresult = false
      let incompleteDate = 0
      this.debtorsitems.forEach(element => {
        if (!element.dataCompleted) {
          incompleteDate += 1
          if (document.getElementById(`debtor-loginStatus-${element.index}`) !== null) {
            this.highlightDebtorsRequiredFields(element)
          }
        }
      })
      if (incompleteDate === 0 && !this.incorrectCVR) {
        this.incorrectCVR = false
        this.noinput = false
        const arr = []
        this.capitalCompanyActive = false
        this.debtorsitems.forEach(element => {
          if (element.fullData.debtortype.value !== 'person') {
            this.capitalCompanyActive = true
          } else {
            this.capitalCompanyActive = false
          }
          arr.push(element.fullData)
        })
        const form = new FormData()
        form.append('creditor_id', this.selectedClient)
        form.append('debt_case_id', this.debt_case_id)
        form.append('data', JSON.stringify(arr))
        const url = `${constants.baseUrl}/upsert-debtor`
        await axios.post(url, form).then(response => {
          if (response.status === 200) {
            response.data.data.debtors.forEach((element, debtorIndex) => {
              this.debtorsitems[debtorIndex].fullData.debtorID = element.id
              this.debtorsitems[debtorIndex].fullData.password.required = false
            })
            this.getDebtors(this.clientId)
          }
          endresult = true
        }).catch(error => {
          this.loader = false
          this.noinput = true
          this.noinputmsg = error.response.data.message ? error.response.data.message : error.message
          endresult = false
        })
        if (endresult) {
          await axios.get(`/get-debt-case/${this.debt_case_id}`).then(response => {
            if (response.status === 200) {
              this.summaryClientName = response.data.data.client.name
              this.summaryClientId = response.data.data.client.id
              this.summaryDocumentBaseType = response.data.data.debt_case.base_type
              this.summaryBaseDocuments = response.data.data.base_documents
              this.summaryCreditNotes = response.data.data.credit_notes
              this.summaryDebtReminders = response.data.data.debt_reminders
              this.summaryOtherFiles = response.data.data.other_files
              this.summaryDebtors = response.data.data.debtors
              this.summaryTotalDebtAmount = !this.capitalCompanyActive && this.debtReminderitems.length > 0 ? this.getTotalAmountMinusDebtReminders(response.data.data.total_payment_amount) : this.formatCurrency(response.data.data.total_payment_amount, this.defaultCurrency)
              this.loader = false
            }
          })
        }
      } else {
        this.loader = false
        this.noinput = true
        this.noinputmsg = this.debtorsBelongToCompany ? i18n.t('DEBTIA_FILL_MANDATORY_FORM_MSG_COMPANY_V1') : i18n.t('DEBTIA_FILL_MANDATORY_FORM_MSG_V1')
        endresult = false
      }
      if (endresult) {
        if (this.customVariables.length > 0) {
          this.$refs.wizard.changeTab(6, 7)
        } else {
          this.$refs.wizard.changeTab(5, 6)
        }
      }
      return endresult
    },
    getTotalAmountMinusDebtReminders(totalAmount) {
      let totalCompensationFee = 0
      this.debtReminderitems.forEach(element => {
        const convertedCompensationFee = Number(element.fullData.compensationFee)
        totalCompensationFee += convertedCompensationFee
      })
      return this.formatCurrency(totalAmount - totalCompensationFee, this.defaultCurrency)
    },
    DKCurrencyConversion(amount) {
      const val = new Intl.NumberFormat('da-DK', { style: 'currency', currency: 'DKK' }).format(parseFloat(amount).toFixed(2))
      return val.replace('kr.', '')
    },
    formatCurrency(amount, defaultCurrency) {
      return new Intl.NumberFormat('da-DK', { style: 'currency', currency: defaultCurrency }).format(parseFloat(amount).toFixed(2))
    },
    async formSubmitted() {
      if (document.getElementById('confirmationCheck').checked) {
        this.loader = true
        const url = `${constants.baseUrl}/create-debt-case`
        await axios.post(url, {
          status: 1,
          debt_case_id: this.debt_case_id,
          termsheetcode: this.selectedTermsheetCode,
        }).then(response => {
          if (response.status === 200) {
            this.loader = false
            this.$nextTick(() => {
              this.$refs['my-modal-cases'].toggle('#toggle-btn')
            })
            this.reloadMethod()
            // this.resetCaseModal()
            // this.$refs['my-modal-cases'].hide()
            this.$toast({
              component: ToastificationContent,
              position: 'top-right',
              props: {
                title: 'Success',
                icon: 'CoffeeIcon',
                variant: 'primary',
                text: i18n.t('DEBTIA_CASE_ADDED_MSG'),
              },
            })
          }
        }).catch(error => {
          this.noinput = true
          this.noinputmsg = error.response.data.message ? error.response.data.message : error.message
          this.loader = false
        })
        return true
      }
      this.noinput = true
      this.noinputmsg = i18n.t('DEBTIA_CONFIRMATION_ALERT_MSG')
      return false
    },
    resetCaseModal() {
      this.postCustomVariables = []
      this.PasswordNotRequired = false
      this.selectedDebtor = ''
      this.selectedClient = ''
      this.selectedTermsheetCode = ''
      this.selectedCaseGroup = ''
      this.nextButton = 'Next'
      this.noinputmsg = ''
      this.noinput = false
      this.debt_case_id = 0
      this.sentAtDate = ''
      this.dueDate = ''
      this.dueDateValid = false
      this.busy = false
      this.processing = false
      this.baseDocumentsIndex = 1
      this.creditNotesIndex = 0
      this.debtReminderIndex = 0
      this.otherFileIndex = 0
      this.debtorIndex = 1
      this.items = [
        {
          index: 1,
          file: '[Add Document]',
          fullData: {
            recordIndex: 1,
            file: '',
            title: '',
            sentAt: '',
            daSentAt: '',
            dueDate: '',
            daDueDate: '',
            paymentAmount: '',
            vatAmount: '',
            amountPaid: {
              status: false,
              value: '',
            },
            interestRate: {
              status: false,
              value: '',
            },
          },
          dataCompleted: false,
        },
      ]
      this.debtReminderitems = []
      this.creditNoteitems = []
      this.otherFilesitems = []
      this.debtorsitems = [
        {
          index: 1,
          file: '[Add Debtor]',
          fullData: {
            recordIndex: 1,
            debtorID: 0,
            username: {
              required: true,
              value: '',
              unique: true,
            },
            password: {
              required: true,
              value: this.$getRandomPassword(),
            },
            loginStatus: {
              required: true,
              value: 1,
            },
            name: {
              required: true,
              value: '',
            },
            co: {
              required: false,
              value: '',
            },
            bank_branch_no: {
              required: false,
              value: '',
            },
            bank_account_no: {
              required: false,
              value: '',
            },
            cpn: {
              required: false,
              value: '',
            },
            debtortype: {
              required: true,
              value: '',
            },
            cpr: {
              required: false,
              value: '',
            },
            cvrnumber: {
              required: false,
              value: '',
            },
            hide_address: false,
            address: {
              road_name: {
                required: true,
                value: '',
              },
              house_number: {
                required: true,
                value: '',
              },
              place: {
                required: false,
                value: '',
              },
              zip_code: {
                required: true,
                value: '',
              },
              court_id: {
                required: false,
                value: 0,
              },
              city: {
                required: true,
                value: '',
              },
              country_id: {
                required: true,
                value: 247,
              },
            },
            phone: {
              required: false,
              value: '',
            },
            email: {
              required: false,
              value: '',
            },
            debtorGeneralDates: {},
          },
          dataCompleted: false,
        },
      ]
      this.clientDebtors = []
      this.activeOption = 0
      this.toGrabIndex = 0
    },
    async resetDebtors() {
      this.loader = true
      this.caseMaxLimit = false
      if (this.clientId) {
        await this.getCaseMaxLimit(this.clientId)
      }
      this.createUsername().then(result => {
        this.debtorsitems = [
          {
            index: 1,
            file: '[Add Debtor]',
            fullData: {
              recordIndex: 1,
              debtorID: 0,
              username: {
                required: true,
                value: result,
                unique: true,
              },
              password: {
                required: true,
                value: this.$getRandomPassword(),
              },
              loginStatus: {
                required: true,
                value: 1,
              },
              name: {
                required: true,
                value: '',
              },
              co: {
                required: false,
                value: '',
              },
              bank_branch_no: {
                required: false,
                value: '',
              },
              bank_account_no: {
                required: false,
                value: '',
              },
              cpn: {
                required: false,
                value: '',
              },
              debtortype: {
                required: true,
                value: '',
              },
              cpr: {
                required: false,
                value: '',
              },
              cvrnumber: {
                required: false,
                value: '',
              },
              court_id: {
                required: false,
                value: 0,
              },
              hide_address: false,
              address: {
                road_name: {
                  required: true,
                  value: '',
                },
                house_number: {
                  required: true,
                  value: '',
                },
                place: {
                  required: false,
                  value: '',
                },
                zip_code: {
                  required: true,
                  value: '',
                },
                court_id: {
                  required: false,
                  value: 0,
                },
                city: {
                  required: true,
                  value: '',
                },
                country_id: {
                  required: true,
                  value: 247,
                },
              },
              phone: {
                required: false,
                value: '',
              },
              email: {
                required: false,
                value: '',
              },
              debtorGeneralDates: {},
            },
            dataCompleted: false,
          },
        ]
        const btnId = 'debtors-btn-1'
        const rowId = document.getElementById(btnId).parentNode.parentNode.parentNode.id
        document.querySelector(`#${rowId} td.fileclass`).innerHTML = '<span>[Add Debtor]</span>'
        document.querySelector(`#${rowId}`).style = 'background-color: #f9f9f9 !important'
        this.loader = false
      })
    },
    // this function will used to make the custom variable object reactive
    customReactiveVar(index) {
      this.debtorReactiveVar = Date.now()
      this.wizardFieldChange('debtors', index)
    },
    onCountryChange(val, itemIndex) {
      const item = itemIndex.fullData.address.city
      if (!item) return
      if (val && item) {
        item.value = ''
      }
    },

    async getCaseMaxLimit(id) {
      // loader is already added where this function has been called
      const url = `/get-client-subscriptions/${id}`
      await axios.get(url).then(response => {
        if (response.status === 200) {
          this.caseMaxLimit = response.data.data.max_limit
        }
      })
        .catch(error => {
          console.log(error.response.data.message ? error.response.data.message : error.message)
        })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/quill.scss';
.ql-container.ql-snow{
  height: 150px !important;
}

.alert.alert-warning{
    width: 100%;
}

.cancel-btn, .variableitem {
  margin-left: 60px;
}

.cancel-btn {
  margin-right: 20px !important;
}

.cancel-btn-one {
  margin-top: 10px;
}

.letter-card {
  padding-bottom:5px;
}

#bcardbody {
  padding-bottom: 0px !important;
}

.first-p {
  width: 60% !important;
}

.margin-top-zero {
  margin-top: 0px;
}

.margin-right-zero {
  margin-right: 0px;
}

.margin-right-ten {
  margin-right: 10px;
}

.variables {
  overflow-y: scroll;
  max-height: 400px;
}

.spacedvariables {
  overflow-y: scroll;
  max-height: 300px;
}

.card-color {
  color : #1b922a;
}

.base-type-options {
    height: 125px;
}

.base-type-options.active {
    border: 2px solid #219289;
    color: #219289;
}

.baseDocRecords {
    margin-top: 25px
}

.base-doc .card-body{
  padding: 0px 0px 10px 0px !important;
}

.meetup-day{
  padding-left: 10px;
}

.margin-left-span {
  margin-left: 9px;
}

@media (min-width: 992px){
  .modal-lg {
    max-width: 1000px;
  }
}

.modal-table thead{
  display: none;
}

button.delete-record {
    margin-right: -35px;
}

.meetup-day-1 {
  margin-top: 8px;
  float: right;
}

.my-auto-1{
  display: inline-block;
}

.response-icon{
  display: inline-block;
  margin-right: 10px;
}

.checkboxActive{
  background-color: #e8fff4 !important;
}

.creditnotesalert{
    width: 100%;
    margin-top: 10px;
}

.debtor-input{
  width: fit-content;
}

.skip-btn{
  margin-left: 10px;
  background-color: #fff0dd;
}

.col-margin {
  margin-top: 15px;
}

.classformgroup {
  margin-bottom: 0px;
}

.card-text-styling {
  padding: 20px;
}

.debtor-row {
  border-bottom: 1px solid #e1e0e5;
  padding-bottom: 15px;
}

.debtor-creds-row {
  margin-top: 20px;
}

.debtor-label{
    margin-right: 20px;
    margin-top: 10px;
}

.debtors-select {
  width: 100%;
}

.address-section{
  border: 1px solid #d8d6de !important;
}

.cvr-error {
  color: red;
  margin-left: 5px;
  font-size: 10px;
}

.cvr-error-show {
  display: block;
}

.cvr-error-hide {
  display: none;
}

.margin-btm {
  margin-bottom: 0.4rem !important;
}

.wizard-tab-content {
  overflow-x: hidden !important;
}

.record-table {
  overflow-x: scroll !important;
}

#first-div {
  margin-bottom: 0px !important;
}

.wizard-icon-circle.md.checked{
  border-color: rgb(238 246 246) !important;
  background-color: rgb(238 246 246) !important;
}

.requiredError {
  border-color: red !important;
}

  @import '@core/scss/vue/libs/vue-wizard.scss';
  @import '@core/scss/vue/libs/vue-select.scss';
  @import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
<style lang="scss" scoped>
@import "~@core/scss/base/pages/app-invoice.scss";
</style>

<style lang="scss">
@media print {

  // Global Styles
  body {
    background-color: transparent !important;
  }
  nav.header-navbar {
    display: none;
  }
  .main-menu {
    display: none;
  }
  .header-navbar-shadow {
    display: none !important;
  }
  .content.app-content {
    margin-left: 0;
    padding-top: 2rem !important;
  }
  footer.footer {
    display: none;
  }
  .card {
    background-color: transparent;
    box-shadow: none;
  }
  .customizer-toggle {
    display: none !important;
  }

  .confirmation-text {
    margin-bottom: 1rem !important;
  }

  // Invoice Specific Styles
  .invoice-preview-wrapper {
    .row.invoice-preview {
      .col-md-8 {
        max-width: 100%;
        flex-grow: 1;
      }

      .invoice-preview-card {
        .card-body:nth-of-type(2) {
          .row {
              > .col-12 {
              max-width: 50% !important;
            }

            .col-12:nth-child(2) {
              display: flex;
              align-items: flex-start;
              justify-content: flex-end;
              margin-top: 0 !important;
            }
          }
        }
      }
    }

    // Action Right Col
    .invoice-actions {
      display: none;
    }
  }
}
.otherfiles_category_id {
  width: 81%;
}

.custom-control.custom-radio {
  margin-top: 5px !important;
}

.custom-variables-body {
  overflow-y: scroll;
  height: 450px;
}

.alert-general-variable {
  color: red;
  display: block;
}

.noShow {
  display: none;
}

.select-list .active {
  background-color: #219289 !important;
}

.timepick-minutes li{
  color: #d0d2d6 !important;
}

.timepick-hours li{
  color: #d0d2d6 !important;;
}

.no-display {
  display: none;
}
</style>
